"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RescaleJob_one_of_decls, _RescaleWebHookResponse_one_of_decls, _RescaleWebHook_one_of_decls, _RescaleJobStatus_one_of_decls, _RescaleJobAnalysis_one_of_decls, _RescaleJobAnalysisWH_one_of_decls, _InputFile_one_of_decls, _PathParts_one_of_decls, _EnvVars_one_of_decls, _Analysis_one_of_decls, _Flags_one_of_decls, _HardwareWH_one_of_decls, _Hardware_one_of_decls, _RceConnector_one_of_decls, _CoreSummary_one_of_decls, _Scheduler_one_of_decls, _InstanceType_one_of_decls, _UserDefinedLicenseSettings_one_of_decls, _FeatureSet_one_of_decls, _StarCCMFeature_one_of_decls, _CoreType_one_of_decls, _RescaleJobVariable_one_of_decls, _RescaleResourceFilter_one_of_decls, _RescaleJobJSONResult_one_of_decls, _RescaleJobOutFiles_one_of_decls, _RescaleJobOutFileDetail_one_of_decls, _RescaleJobResult_one_of_decls, _RescaleJobStatusHistory_one_of_decls, _RescaleJobStatusHistDetail_one_of_decls, _RescaleClusterStatusHistory_one_of_decls, _RescaleClusterStatusHistDetail_one_of_decls;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RescaleClusterStatusHistDetail = exports.RescaleClusterStatusHistory = exports.RescaleJobStatusHistDetail = exports.RescaleJobStatusHistory = exports.RescaleJobResult = exports.RescaleJobOutFileDetail = exports.RescaleJobOutFiles = exports.RescaleJobJSONResult = exports.RescaleResourceFilter = exports.RescaleJobVariable = exports.CoreType = exports.StarCCMFeature = exports.FeatureSet = exports.UserDefinedLicenseSettings = exports.InstanceType = exports.Scheduler = exports.CoreSummary = exports.RceConnector = exports.Hardware = exports.HardwareWH = exports.Flags = exports.Analysis = exports.EnvVars = exports.PathParts = exports.InputFile = exports.RescaleJobAnalysisWH = exports.RescaleJobAnalysis = exports.RescaleJobStatus = exports.RescaleWebHook = exports.RescaleWebHookResponse = exports.RescaleJob = exports.RescaleVariableType = exports.RescaleBillingPriorityValue = void 0;
/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.35.1
 * source: RescaleProto.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
const pb_1 = __importStar(require("google-protobuf"));
var RescaleBillingPriorityValue;
(function (RescaleBillingPriorityValue) {
    RescaleBillingPriorityValue[RescaleBillingPriorityValue["NOT_USED_VAL"] = 0] = "NOT_USED_VAL";
    RescaleBillingPriorityValue[RescaleBillingPriorityValue["INSTANT"] = 1] = "INSTANT";
    RescaleBillingPriorityValue[RescaleBillingPriorityValue["ON_DEMAND"] = 2] = "ON_DEMAND";
    RescaleBillingPriorityValue[RescaleBillingPriorityValue["RESERVED"] = 3] = "RESERVED";
})(RescaleBillingPriorityValue || (exports.RescaleBillingPriorityValue = RescaleBillingPriorityValue = {}));
var RescaleVariableType;
(function (RescaleVariableType) {
    RescaleVariableType[RescaleVariableType["NOT_USED_VAL_0"] = 0] = "NOT_USED_VAL_0";
    RescaleVariableType[RescaleVariableType["Param"] = 1] = "Param";
    RescaleVariableType[RescaleVariableType["Design"] = 2] = "Design";
    RescaleVariableType[RescaleVariableType["Output"] = 3] = "Output";
    RescaleVariableType[RescaleVariableType["Case"] = 4] = "Case";
    RescaleVariableType[RescaleVariableType["Constraint"] = 5] = "Constraint";
    RescaleVariableType[RescaleVariableType["Objective"] = 6] = "Objective";
})(RescaleVariableType || (exports.RescaleVariableType = RescaleVariableType = {}));
class RescaleJob extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJob_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4, 5, 6], __classPrivateFieldGet(this, _RescaleJob_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("paramFile" in data && data.paramFile != undefined) {
                this.paramFile = data.paramFile;
            }
            if ("caseFile" in data && data.caseFile != undefined) {
                this.caseFile = data.caseFile;
            }
            if ("jobvariables" in data && data.jobvariables != undefined) {
                this.jobvariables = data.jobvariables;
            }
            if ("jobanalyses" in data && data.jobanalyses != undefined) {
                this.jobanalyses = data.jobanalyses;
            }
            if ("resourcefilters" in data && data.resourcefilters != undefined) {
                this.resourcefilters = data.resourcefilters;
            }
            if ("isTemplateDryRun" in data && data.isTemplateDryRun != undefined) {
                this.isTemplateDryRun = data.isTemplateDryRun;
            }
            if ("includeNominalRun" in data && data.includeNominalRun != undefined) {
                this.includeNominalRun = data.includeNominalRun;
            }
            if ("monteCarloIterations" in data && data.monteCarloIterations != undefined) {
                this.monteCarloIterations = data.monteCarloIterations;
            }
            if ("billingPriorityValue" in data && data.billingPriorityValue != undefined) {
                this.billingPriorityValue = data.billingPriorityValue;
            }
            if ("operation" in data && data.operation != undefined) {
                this.operation = data.operation;
            }
            if ("jobIdentifier" in data && data.jobIdentifier != undefined) {
                this.jobIdentifier = data.jobIdentifier;
            }
            if ("gmWorkflowMgmt" in data && data.gmWorkflowMgmt != undefined) {
                this.gmWorkflowMgmt = data.gmWorkflowMgmt;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get paramFile() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set paramFile(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get caseFile() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set caseFile(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get jobvariables() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleJobVariable, 4);
    }
    set jobvariables(value) {
        pb_1.Message.setRepeatedWrapperField(this, 4, value);
    }
    get jobanalyses() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleJobAnalysis, 5);
    }
    set jobanalyses(value) {
        pb_1.Message.setRepeatedWrapperField(this, 5, value);
    }
    get resourcefilters() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleResourceFilter, 6);
    }
    set resourcefilters(value) {
        pb_1.Message.setRepeatedWrapperField(this, 6, value);
    }
    get isTemplateDryRun() {
        return pb_1.Message.getFieldWithDefault(this, 7, false);
    }
    set isTemplateDryRun(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get includeNominalRun() {
        return pb_1.Message.getFieldWithDefault(this, 8, false);
    }
    set includeNominalRun(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get monteCarloIterations() {
        return pb_1.Message.getFieldWithDefault(this, 9, 0);
    }
    set monteCarloIterations(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get billingPriorityValue() {
        return pb_1.Message.getFieldWithDefault(this, 10, RescaleBillingPriorityValue.NOT_USED_VAL);
    }
    set billingPriorityValue(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get operation() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set operation(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get jobIdentifier() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set jobIdentifier(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get gmWorkflowMgmt() {
        return pb_1.Message.getFieldWithDefault(this, 13, false);
    }
    set gmWorkflowMgmt(value) {
        pb_1.Message.setField(this, 13, value);
    }
    static fromObject(data) {
        const message = new RescaleJob({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.paramFile != null) {
            message.paramFile = data.paramFile;
        }
        if (data.caseFile != null) {
            message.caseFile = data.caseFile;
        }
        if (data.jobvariables != null) {
            message.jobvariables = data.jobvariables.map(item => RescaleJobVariable.fromObject(item));
        }
        if (data.jobanalyses != null) {
            message.jobanalyses = data.jobanalyses.map(item => RescaleJobAnalysis.fromObject(item));
        }
        if (data.resourcefilters != null) {
            message.resourcefilters = data.resourcefilters.map(item => RescaleResourceFilter.fromObject(item));
        }
        if (data.isTemplateDryRun != null) {
            message.isTemplateDryRun = data.isTemplateDryRun;
        }
        if (data.includeNominalRun != null) {
            message.includeNominalRun = data.includeNominalRun;
        }
        if (data.monteCarloIterations != null) {
            message.monteCarloIterations = data.monteCarloIterations;
        }
        if (data.billingPriorityValue != null) {
            message.billingPriorityValue = data.billingPriorityValue;
        }
        if (data.operation != null) {
            message.operation = data.operation;
        }
        if (data.jobIdentifier != null) {
            message.jobIdentifier = data.jobIdentifier;
        }
        if (data.gmWorkflowMgmt != null) {
            message.gmWorkflowMgmt = data.gmWorkflowMgmt;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.paramFile != null) {
            data.paramFile = this.paramFile;
        }
        if (this.caseFile != null) {
            data.caseFile = this.caseFile;
        }
        if (this.jobvariables != null) {
            data.jobvariables = this.jobvariables.map((item) => item.toObject());
        }
        if (this.jobanalyses != null) {
            data.jobanalyses = this.jobanalyses.map((item) => item.toObject());
        }
        if (this.resourcefilters != null) {
            data.resourcefilters = this.resourcefilters.map((item) => item.toObject());
        }
        if (this.isTemplateDryRun != null) {
            data.isTemplateDryRun = this.isTemplateDryRun;
        }
        if (this.includeNominalRun != null) {
            data.includeNominalRun = this.includeNominalRun;
        }
        if (this.monteCarloIterations != null) {
            data.monteCarloIterations = this.monteCarloIterations;
        }
        if (this.billingPriorityValue != null) {
            data.billingPriorityValue = this.billingPriorityValue;
        }
        if (this.operation != null) {
            data.operation = this.operation;
        }
        if (this.jobIdentifier != null) {
            data.jobIdentifier = this.jobIdentifier;
        }
        if (this.gmWorkflowMgmt != null) {
            data.gmWorkflowMgmt = this.gmWorkflowMgmt;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.paramFile.length)
            writer.writeString(2, this.paramFile);
        if (this.caseFile.length)
            writer.writeString(3, this.caseFile);
        if (this.jobvariables.length)
            writer.writeRepeatedMessage(4, this.jobvariables, (item) => item.serialize(writer));
        if (this.jobanalyses.length)
            writer.writeRepeatedMessage(5, this.jobanalyses, (item) => item.serialize(writer));
        if (this.resourcefilters.length)
            writer.writeRepeatedMessage(6, this.resourcefilters, (item) => item.serialize(writer));
        if (this.isTemplateDryRun != false)
            writer.writeBool(7, this.isTemplateDryRun);
        if (this.includeNominalRun != false)
            writer.writeBool(8, this.includeNominalRun);
        if (this.monteCarloIterations != 0)
            writer.writeInt32(9, this.monteCarloIterations);
        if (this.billingPriorityValue != RescaleBillingPriorityValue.NOT_USED_VAL)
            writer.writeEnum(10, this.billingPriorityValue);
        if (this.operation.length)
            writer.writeString(11, this.operation);
        if (this.jobIdentifier.length)
            writer.writeString(12, this.jobIdentifier);
        if (this.gmWorkflowMgmt != false)
            writer.writeBool(13, this.gmWorkflowMgmt);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJob();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.paramFile = reader.readString();
                    break;
                case 3:
                    message.caseFile = reader.readString();
                    break;
                case 4:
                    reader.readMessage(message.jobvariables, () => pb_1.Message.addToRepeatedWrapperField(message, 4, RescaleJobVariable.deserialize(reader), RescaleJobVariable));
                    break;
                case 5:
                    reader.readMessage(message.jobanalyses, () => pb_1.Message.addToRepeatedWrapperField(message, 5, RescaleJobAnalysis.deserialize(reader), RescaleJobAnalysis));
                    break;
                case 6:
                    reader.readMessage(message.resourcefilters, () => pb_1.Message.addToRepeatedWrapperField(message, 6, RescaleResourceFilter.deserialize(reader), RescaleResourceFilter));
                    break;
                case 7:
                    message.isTemplateDryRun = reader.readBool();
                    break;
                case 8:
                    message.includeNominalRun = reader.readBool();
                    break;
                case 9:
                    message.monteCarloIterations = reader.readInt32();
                    break;
                case 10:
                    message.billingPriorityValue = reader.readEnum();
                    break;
                case 11:
                    message.operation = reader.readString();
                    break;
                case 12:
                    message.jobIdentifier = reader.readString();
                    break;
                case 13:
                    message.gmWorkflowMgmt = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJob.deserialize(bytes);
    }
}
exports.RescaleJob = RescaleJob;
_RescaleJob_one_of_decls = new WeakMap();
class RescaleWebHookResponse extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleWebHookResponse_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RescaleWebHookResponse_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("current" in data && data.current != undefined) {
                this.current = data.current;
            }
        }
    }
    get current() {
        return pb_1.Message.getWrapperField(this, RescaleWebHook, 1);
    }
    set current(value) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_current() {
        return pb_1.Message.getField(this, 1) != null;
    }
    static fromObject(data) {
        const message = new RescaleWebHookResponse({});
        if (data.current != null) {
            message.current = RescaleWebHook.fromObject(data.current);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.current != null) {
            data.current = this.current.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_current)
            writer.writeMessage(1, this.current, () => this.current.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleWebHookResponse();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.current, () => message.current = RescaleWebHook.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleWebHookResponse.deserialize(bytes);
    }
}
exports.RescaleWebHookResponse = RescaleWebHookResponse;
_RescaleWebHookResponse_one_of_decls = new WeakMap();
class RescaleWebHook extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleWebHook_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [25, 26, 5, 4, 6], __classPrivateFieldGet(this, _RescaleWebHook_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) {
                this.id = data.id;
            }
            if ("isLowPriority" in data && data.isLowPriority != undefined) {
                this.isLowPriority = data.isLowPriority;
            }
            if ("billingPriorityValue" in data && data.billingPriorityValue != undefined) {
                this.billingPriorityValue = data.billingPriorityValue;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("autosuspend" in data && data.autosuspend != undefined) {
                this.autosuspend = data.autosuspend;
            }
            if ("suspensionStatus" in data && data.suspensionStatus != undefined) {
                this.suspensionStatus = data.suspensionStatus;
            }
            if ("suspendAvailable" in data && data.suspendAvailable != undefined) {
                this.suspendAvailable = data.suspendAvailable;
            }
            if ("elapsedWalltimeSeconds" in data && data.elapsedWalltimeSeconds != undefined) {
                this.elapsedWalltimeSeconds = data.elapsedWalltimeSeconds;
            }
            if ("currentUserHasFullAccess" in data && data.currentUserHasFullAccess != undefined) {
                this.currentUserHasFullAccess = data.currentUserHasFullAccess;
            }
            if ("clonedFrom" in data && data.clonedFrom != undefined) {
                this.clonedFrom = data.clonedFrom;
            }
            if ("templatedFrom" in data && data.templatedFrom != undefined) {
                this.templatedFrom = data.templatedFrom;
            }
            if ("isTemplate" in data && data.isTemplate != undefined) {
                this.isTemplate = data.isTemplate;
            }
            if ("cidrRule" in data && data.cidrRule != undefined) {
                this.cidrRule = data.cidrRule;
            }
            if ("publicKey" in data && data.publicKey != undefined) {
                this.publicKey = data.publicKey;
            }
            if ("sshPort" in data && data.sshPort != undefined) {
                this.sshPort = data.sshPort;
            }
            if ("dateInserted" in data && data.dateInserted != undefined) {
                this.dateInserted = data.dateInserted;
            }
            if ("isPinned" in data && data.isPinned != undefined) {
                this.isPinned = data.isPinned;
            }
            if ("userTags" in data && data.userTags != undefined) {
                this.userTags = data.userTags;
            }
            if ("launchConfigs" in data && data.launchConfigs != undefined) {
                this.launchConfigs = data.launchConfigs;
            }
            if ("jobanalyses" in data && data.jobanalyses != undefined) {
                this.jobanalyses = data.jobanalyses;
            }
            if ("jobvariables" in data && data.jobvariables != undefined) {
                this.jobvariables = data.jobvariables;
            }
            if ("resourcefilters" in data && data.resourcefilters != undefined) {
                this.resourcefilters = data.resourcefilters;
            }
            if ("isTemplateDryRun" in data && data.isTemplateDryRun != undefined) {
                this.isTemplateDryRun = data.isTemplateDryRun;
            }
            if ("includeNominalRun" in data && data.includeNominalRun != undefined) {
                this.includeNominalRun = data.includeNominalRun;
            }
            if ("monteCarloIterations" in data && data.monteCarloIterations != undefined) {
                this.monteCarloIterations = data.monteCarloIterations;
            }
            if ("operation" in data && data.operation != undefined) {
                this.operation = data.operation;
            }
            if ("jobIdentifier" in data && data.jobIdentifier != undefined) {
                this.jobIdentifier = data.jobIdentifier;
            }
            if ("latestStatus" in data && data.latestStatus != undefined) {
                this.latestStatus = data.latestStatus;
            }
        }
    }
    get id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get isLowPriority() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set isLowPriority(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get billingPriorityValue() {
        return pb_1.Message.getFieldWithDefault(this, 3, RescaleBillingPriorityValue.NOT_USED_VAL);
    }
    set billingPriorityValue(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get autosuspend() {
        return pb_1.Message.getFieldWithDefault(this, 12, false);
    }
    set autosuspend(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get suspensionStatus() {
        return pb_1.Message.getFieldWithDefault(this, 13, "");
    }
    set suspensionStatus(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get suspendAvailable() {
        return pb_1.Message.getFieldWithDefault(this, 14, "");
    }
    set suspendAvailable(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get elapsedWalltimeSeconds() {
        return pb_1.Message.getFieldWithDefault(this, 15, 0);
    }
    set elapsedWalltimeSeconds(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get currentUserHasFullAccess() {
        return pb_1.Message.getFieldWithDefault(this, 16, false);
    }
    set currentUserHasFullAccess(value) {
        pb_1.Message.setField(this, 16, value);
    }
    get clonedFrom() {
        return pb_1.Message.getFieldWithDefault(this, 17, "");
    }
    set clonedFrom(value) {
        pb_1.Message.setField(this, 17, value);
    }
    get templatedFrom() {
        return pb_1.Message.getFieldWithDefault(this, 18, "");
    }
    set templatedFrom(value) {
        pb_1.Message.setField(this, 18, value);
    }
    get isTemplate() {
        return pb_1.Message.getFieldWithDefault(this, 19, false);
    }
    set isTemplate(value) {
        pb_1.Message.setField(this, 19, value);
    }
    get cidrRule() {
        return pb_1.Message.getFieldWithDefault(this, 20, "");
    }
    set cidrRule(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get publicKey() {
        return pb_1.Message.getFieldWithDefault(this, 21, "");
    }
    set publicKey(value) {
        pb_1.Message.setField(this, 21, value);
    }
    get sshPort() {
        return pb_1.Message.getFieldWithDefault(this, 22, 0);
    }
    set sshPort(value) {
        pb_1.Message.setField(this, 22, value);
    }
    get dateInserted() {
        return pb_1.Message.getFieldWithDefault(this, 23, "");
    }
    set dateInserted(value) {
        pb_1.Message.setField(this, 23, value);
    }
    get isPinned() {
        return pb_1.Message.getFieldWithDefault(this, 24, false);
    }
    set isPinned(value) {
        pb_1.Message.setField(this, 24, value);
    }
    get userTags() {
        return pb_1.Message.getFieldWithDefault(this, 25, []);
    }
    set userTags(value) {
        pb_1.Message.setField(this, 25, value);
    }
    get launchConfigs() {
        return pb_1.Message.getFieldWithDefault(this, 26, []);
    }
    set launchConfigs(value) {
        pb_1.Message.setField(this, 26, value);
    }
    get jobanalyses() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleJobAnalysisWH, 5);
    }
    set jobanalyses(value) {
        pb_1.Message.setRepeatedWrapperField(this, 5, value);
    }
    get jobvariables() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleJobVariable, 4);
    }
    set jobvariables(value) {
        pb_1.Message.setRepeatedWrapperField(this, 4, value);
    }
    get resourcefilters() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleResourceFilter, 6);
    }
    set resourcefilters(value) {
        pb_1.Message.setRepeatedWrapperField(this, 6, value);
    }
    get isTemplateDryRun() {
        return pb_1.Message.getFieldWithDefault(this, 7, false);
    }
    set isTemplateDryRun(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get includeNominalRun() {
        return pb_1.Message.getFieldWithDefault(this, 8, false);
    }
    set includeNominalRun(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get monteCarloIterations() {
        return pb_1.Message.getFieldWithDefault(this, 9, 0);
    }
    set monteCarloIterations(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get operation() {
        return pb_1.Message.getFieldWithDefault(this, 27, "");
    }
    set operation(value) {
        pb_1.Message.setField(this, 27, value);
    }
    get jobIdentifier() {
        return pb_1.Message.getFieldWithDefault(this, 28, "");
    }
    set jobIdentifier(value) {
        pb_1.Message.setField(this, 28, value);
    }
    get latestStatus() {
        return pb_1.Message.getWrapperField(this, RescaleJobStatus, 29);
    }
    set latestStatus(value) {
        pb_1.Message.setWrapperField(this, 29, value);
    }
    get has_latestStatus() {
        return pb_1.Message.getField(this, 29) != null;
    }
    static fromObject(data) {
        const message = new RescaleWebHook({});
        if (data.id != null) {
            message.id = data.id;
        }
        if (data.isLowPriority != null) {
            message.isLowPriority = data.isLowPriority;
        }
        if (data.billingPriorityValue != null) {
            message.billingPriorityValue = data.billingPriorityValue;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.autosuspend != null) {
            message.autosuspend = data.autosuspend;
        }
        if (data.suspensionStatus != null) {
            message.suspensionStatus = data.suspensionStatus;
        }
        if (data.suspendAvailable != null) {
            message.suspendAvailable = data.suspendAvailable;
        }
        if (data.elapsedWalltimeSeconds != null) {
            message.elapsedWalltimeSeconds = data.elapsedWalltimeSeconds;
        }
        if (data.currentUserHasFullAccess != null) {
            message.currentUserHasFullAccess = data.currentUserHasFullAccess;
        }
        if (data.clonedFrom != null) {
            message.clonedFrom = data.clonedFrom;
        }
        if (data.templatedFrom != null) {
            message.templatedFrom = data.templatedFrom;
        }
        if (data.isTemplate != null) {
            message.isTemplate = data.isTemplate;
        }
        if (data.cidrRule != null) {
            message.cidrRule = data.cidrRule;
        }
        if (data.publicKey != null) {
            message.publicKey = data.publicKey;
        }
        if (data.sshPort != null) {
            message.sshPort = data.sshPort;
        }
        if (data.dateInserted != null) {
            message.dateInserted = data.dateInserted;
        }
        if (data.isPinned != null) {
            message.isPinned = data.isPinned;
        }
        if (data.userTags != null) {
            message.userTags = data.userTags;
        }
        if (data.launchConfigs != null) {
            message.launchConfigs = data.launchConfigs;
        }
        if (data.jobanalyses != null) {
            message.jobanalyses = data.jobanalyses.map(item => RescaleJobAnalysisWH.fromObject(item));
        }
        if (data.jobvariables != null) {
            message.jobvariables = data.jobvariables.map(item => RescaleJobVariable.fromObject(item));
        }
        if (data.resourcefilters != null) {
            message.resourcefilters = data.resourcefilters.map(item => RescaleResourceFilter.fromObject(item));
        }
        if (data.isTemplateDryRun != null) {
            message.isTemplateDryRun = data.isTemplateDryRun;
        }
        if (data.includeNominalRun != null) {
            message.includeNominalRun = data.includeNominalRun;
        }
        if (data.monteCarloIterations != null) {
            message.monteCarloIterations = data.monteCarloIterations;
        }
        if (data.operation != null) {
            message.operation = data.operation;
        }
        if (data.jobIdentifier != null) {
            message.jobIdentifier = data.jobIdentifier;
        }
        if (data.latestStatus != null) {
            message.latestStatus = RescaleJobStatus.fromObject(data.latestStatus);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.id != null) {
            data.id = this.id;
        }
        if (this.isLowPriority != null) {
            data.isLowPriority = this.isLowPriority;
        }
        if (this.billingPriorityValue != null) {
            data.billingPriorityValue = this.billingPriorityValue;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.autosuspend != null) {
            data.autosuspend = this.autosuspend;
        }
        if (this.suspensionStatus != null) {
            data.suspensionStatus = this.suspensionStatus;
        }
        if (this.suspendAvailable != null) {
            data.suspendAvailable = this.suspendAvailable;
        }
        if (this.elapsedWalltimeSeconds != null) {
            data.elapsedWalltimeSeconds = this.elapsedWalltimeSeconds;
        }
        if (this.currentUserHasFullAccess != null) {
            data.currentUserHasFullAccess = this.currentUserHasFullAccess;
        }
        if (this.clonedFrom != null) {
            data.clonedFrom = this.clonedFrom;
        }
        if (this.templatedFrom != null) {
            data.templatedFrom = this.templatedFrom;
        }
        if (this.isTemplate != null) {
            data.isTemplate = this.isTemplate;
        }
        if (this.cidrRule != null) {
            data.cidrRule = this.cidrRule;
        }
        if (this.publicKey != null) {
            data.publicKey = this.publicKey;
        }
        if (this.sshPort != null) {
            data.sshPort = this.sshPort;
        }
        if (this.dateInserted != null) {
            data.dateInserted = this.dateInserted;
        }
        if (this.isPinned != null) {
            data.isPinned = this.isPinned;
        }
        if (this.userTags != null) {
            data.userTags = this.userTags;
        }
        if (this.launchConfigs != null) {
            data.launchConfigs = this.launchConfigs;
        }
        if (this.jobanalyses != null) {
            data.jobanalyses = this.jobanalyses.map((item) => item.toObject());
        }
        if (this.jobvariables != null) {
            data.jobvariables = this.jobvariables.map((item) => item.toObject());
        }
        if (this.resourcefilters != null) {
            data.resourcefilters = this.resourcefilters.map((item) => item.toObject());
        }
        if (this.isTemplateDryRun != null) {
            data.isTemplateDryRun = this.isTemplateDryRun;
        }
        if (this.includeNominalRun != null) {
            data.includeNominalRun = this.includeNominalRun;
        }
        if (this.monteCarloIterations != null) {
            data.monteCarloIterations = this.monteCarloIterations;
        }
        if (this.operation != null) {
            data.operation = this.operation;
        }
        if (this.jobIdentifier != null) {
            data.jobIdentifier = this.jobIdentifier;
        }
        if (this.latestStatus != null) {
            data.latestStatus = this.latestStatus.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.id.length)
            writer.writeString(1, this.id);
        if (this.isLowPriority.length)
            writer.writeString(2, this.isLowPriority);
        if (this.billingPriorityValue != RescaleBillingPriorityValue.NOT_USED_VAL)
            writer.writeEnum(3, this.billingPriorityValue);
        if (this.name.length)
            writer.writeString(10, this.name);
        if (this.description.length)
            writer.writeString(11, this.description);
        if (this.autosuspend != false)
            writer.writeBool(12, this.autosuspend);
        if (this.suspensionStatus.length)
            writer.writeString(13, this.suspensionStatus);
        if (this.suspendAvailable.length)
            writer.writeString(14, this.suspendAvailable);
        if (this.elapsedWalltimeSeconds != 0)
            writer.writeFloat(15, this.elapsedWalltimeSeconds);
        if (this.currentUserHasFullAccess != false)
            writer.writeBool(16, this.currentUserHasFullAccess);
        if (this.clonedFrom.length)
            writer.writeString(17, this.clonedFrom);
        if (this.templatedFrom.length)
            writer.writeString(18, this.templatedFrom);
        if (this.isTemplate != false)
            writer.writeBool(19, this.isTemplate);
        if (this.cidrRule.length)
            writer.writeString(20, this.cidrRule);
        if (this.publicKey.length)
            writer.writeString(21, this.publicKey);
        if (this.sshPort != 0)
            writer.writeInt32(22, this.sshPort);
        if (this.dateInserted.length)
            writer.writeString(23, this.dateInserted);
        if (this.isPinned != false)
            writer.writeBool(24, this.isPinned);
        if (this.userTags.length)
            writer.writeRepeatedString(25, this.userTags);
        if (this.launchConfigs.length)
            writer.writeRepeatedString(26, this.launchConfigs);
        if (this.jobanalyses.length)
            writer.writeRepeatedMessage(5, this.jobanalyses, (item) => item.serialize(writer));
        if (this.jobvariables.length)
            writer.writeRepeatedMessage(4, this.jobvariables, (item) => item.serialize(writer));
        if (this.resourcefilters.length)
            writer.writeRepeatedMessage(6, this.resourcefilters, (item) => item.serialize(writer));
        if (this.isTemplateDryRun != false)
            writer.writeBool(7, this.isTemplateDryRun);
        if (this.includeNominalRun != false)
            writer.writeBool(8, this.includeNominalRun);
        if (this.monteCarloIterations != 0)
            writer.writeInt32(9, this.monteCarloIterations);
        if (this.operation.length)
            writer.writeString(27, this.operation);
        if (this.jobIdentifier.length)
            writer.writeString(28, this.jobIdentifier);
        if (this.has_latestStatus)
            writer.writeMessage(29, this.latestStatus, () => this.latestStatus.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleWebHook();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.id = reader.readString();
                    break;
                case 2:
                    message.isLowPriority = reader.readString();
                    break;
                case 3:
                    message.billingPriorityValue = reader.readEnum();
                    break;
                case 10:
                    message.name = reader.readString();
                    break;
                case 11:
                    message.description = reader.readString();
                    break;
                case 12:
                    message.autosuspend = reader.readBool();
                    break;
                case 13:
                    message.suspensionStatus = reader.readString();
                    break;
                case 14:
                    message.suspendAvailable = reader.readString();
                    break;
                case 15:
                    message.elapsedWalltimeSeconds = reader.readFloat();
                    break;
                case 16:
                    message.currentUserHasFullAccess = reader.readBool();
                    break;
                case 17:
                    message.clonedFrom = reader.readString();
                    break;
                case 18:
                    message.templatedFrom = reader.readString();
                    break;
                case 19:
                    message.isTemplate = reader.readBool();
                    break;
                case 20:
                    message.cidrRule = reader.readString();
                    break;
                case 21:
                    message.publicKey = reader.readString();
                    break;
                case 22:
                    message.sshPort = reader.readInt32();
                    break;
                case 23:
                    message.dateInserted = reader.readString();
                    break;
                case 24:
                    message.isPinned = reader.readBool();
                    break;
                case 25:
                    pb_1.Message.addToRepeatedField(message, 25, reader.readString());
                    break;
                case 26:
                    pb_1.Message.addToRepeatedField(message, 26, reader.readString());
                    break;
                case 5:
                    reader.readMessage(message.jobanalyses, () => pb_1.Message.addToRepeatedWrapperField(message, 5, RescaleJobAnalysisWH.deserialize(reader), RescaleJobAnalysisWH));
                    break;
                case 4:
                    reader.readMessage(message.jobvariables, () => pb_1.Message.addToRepeatedWrapperField(message, 4, RescaleJobVariable.deserialize(reader), RescaleJobVariable));
                    break;
                case 6:
                    reader.readMessage(message.resourcefilters, () => pb_1.Message.addToRepeatedWrapperField(message, 6, RescaleResourceFilter.deserialize(reader), RescaleResourceFilter));
                    break;
                case 7:
                    message.isTemplateDryRun = reader.readBool();
                    break;
                case 8:
                    message.includeNominalRun = reader.readBool();
                    break;
                case 9:
                    message.monteCarloIterations = reader.readInt32();
                    break;
                case 27:
                    message.operation = reader.readString();
                    break;
                case 28:
                    message.jobIdentifier = reader.readString();
                    break;
                case 29:
                    reader.readMessage(message.latestStatus, () => message.latestStatus = RescaleJobStatus.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleWebHook.deserialize(bytes);
    }
}
exports.RescaleWebHook = RescaleWebHook;
_RescaleWebHook_one_of_decls = new WeakMap();
class RescaleJobStatus extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobStatus_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RescaleJobStatus_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("status" in data && data.status != undefined) {
                this.status = data.status;
            }
            if ("statusReason" in data && data.statusReason != undefined) {
                this.statusReason = data.statusReason;
            }
            if ("statusDate" in data && data.statusDate != undefined) {
                this.statusDate = data.statusDate;
            }
            if ("id" in data && data.id != undefined) {
                this.id = data.id;
            }
            if ("jobId" in data && data.jobId != undefined) {
                this.jobId = data.jobId;
            }
        }
    }
    get status() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set status(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get statusReason() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set statusReason(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get statusDate() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set statusDate(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get id() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set id(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get jobId() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set jobId(value) {
        pb_1.Message.setField(this, 5, value);
    }
    static fromObject(data) {
        const message = new RescaleJobStatus({});
        if (data.status != null) {
            message.status = data.status;
        }
        if (data.statusReason != null) {
            message.statusReason = data.statusReason;
        }
        if (data.statusDate != null) {
            message.statusDate = data.statusDate;
        }
        if (data.id != null) {
            message.id = data.id;
        }
        if (data.jobId != null) {
            message.jobId = data.jobId;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.status != null) {
            data.status = this.status;
        }
        if (this.statusReason != null) {
            data.statusReason = this.statusReason;
        }
        if (this.statusDate != null) {
            data.statusDate = this.statusDate;
        }
        if (this.id != null) {
            data.id = this.id;
        }
        if (this.jobId != null) {
            data.jobId = this.jobId;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.status.length)
            writer.writeString(1, this.status);
        if (this.statusReason.length)
            writer.writeString(2, this.statusReason);
        if (this.statusDate.length)
            writer.writeString(3, this.statusDate);
        if (this.id.length)
            writer.writeString(4, this.id);
        if (this.jobId.length)
            writer.writeString(5, this.jobId);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobStatus();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.status = reader.readString();
                    break;
                case 2:
                    message.statusReason = reader.readString();
                    break;
                case 3:
                    message.statusDate = reader.readString();
                    break;
                case 4:
                    message.id = reader.readString();
                    break;
                case 5:
                    message.jobId = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobStatus.deserialize(bytes);
    }
}
exports.RescaleJobStatus = RescaleJobStatus;
_RescaleJobStatus_one_of_decls = new WeakMap();
class RescaleJobAnalysis extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobAnalysis_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [9, 14, 15], __classPrivateFieldGet(this, _RescaleJobAnalysis_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("envVars" in data && data.envVars != undefined) {
                this.envVars = data.envVars;
            }
            if ("useRescaleLicense" in data && data.useRescaleLicense != undefined) {
                this.useRescaleLicense = data.useRescaleLicense;
            }
            if ("onDemandLicenseSeller" in data && data.onDemandLicenseSeller != undefined) {
                this.onDemandLicenseSeller = data.onDemandLicenseSeller;
            }
            if ("userDefinedLicenseSettings" in data && data.userDefinedLicenseSettings != undefined) {
                this.userDefinedLicenseSettings = data.userDefinedLicenseSettings;
            }
            if ("analysis" in data && data.analysis != undefined) {
                this.analysis = data.analysis;
            }
            if ("command" in data && data.command != undefined) {
                this.command = data.command;
            }
            if ("flags" in data && data.flags != undefined) {
                this.flags = data.flags;
            }
            if ("hardware" in data && data.hardware != undefined) {
                this.hardware = data.hardware;
            }
            if ("inputFolders" in data && data.inputFolders != undefined) {
                this.inputFolders = data.inputFolders;
            }
            if ("postProcessScript" in data && data.postProcessScript != undefined) {
                this.postProcessScript = data.postProcessScript;
            }
            if ("postProcessScriptCommand" in data && data.postProcessScriptCommand != undefined) {
                this.postProcessScriptCommand = data.postProcessScriptCommand;
            }
            if ("preProcessScript" in data && data.preProcessScript != undefined) {
                this.preProcessScript = data.preProcessScript;
            }
            if ("preProcessScriptCommand" in data && data.preProcessScriptCommand != undefined) {
                this.preProcessScriptCommand = data.preProcessScriptCommand;
            }
            if ("templateTasks" in data && data.templateTasks != undefined) {
                this.templateTasks = data.templateTasks;
            }
            if ("inputFiles" in data && data.inputFiles != undefined) {
                this.inputFiles = data.inputFiles;
            }
        }
    }
    get envVars() {
        return pb_1.Message.getWrapperField(this, EnvVars, 1);
    }
    set envVars(value) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_envVars() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get useRescaleLicense() {
        return pb_1.Message.getFieldWithDefault(this, 2, false);
    }
    set useRescaleLicense(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get onDemandLicenseSeller() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set onDemandLicenseSeller(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get userDefinedLicenseSettings() {
        return pb_1.Message.getWrapperField(this, UserDefinedLicenseSettings, 4);
    }
    set userDefinedLicenseSettings(value) {
        pb_1.Message.setWrapperField(this, 4, value);
    }
    get has_userDefinedLicenseSettings() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get analysis() {
        return pb_1.Message.getWrapperField(this, Analysis, 5);
    }
    set analysis(value) {
        pb_1.Message.setWrapperField(this, 5, value);
    }
    get has_analysis() {
        return pb_1.Message.getField(this, 5) != null;
    }
    get command() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set command(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get flags() {
        return pb_1.Message.getWrapperField(this, Flags, 7);
    }
    set flags(value) {
        pb_1.Message.setWrapperField(this, 7, value);
    }
    get has_flags() {
        return pb_1.Message.getField(this, 7) != null;
    }
    get hardware() {
        return pb_1.Message.getWrapperField(this, Hardware, 8);
    }
    set hardware(value) {
        pb_1.Message.setWrapperField(this, 8, value);
    }
    get has_hardware() {
        return pb_1.Message.getField(this, 8) != null;
    }
    get inputFolders() {
        return pb_1.Message.getFieldWithDefault(this, 9, []);
    }
    set inputFolders(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get postProcessScript() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set postProcessScript(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get postProcessScriptCommand() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set postProcessScriptCommand(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get preProcessScript() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set preProcessScript(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get preProcessScriptCommand() {
        return pb_1.Message.getFieldWithDefault(this, 13, "");
    }
    set preProcessScriptCommand(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get templateTasks() {
        return pb_1.Message.getFieldWithDefault(this, 14, []);
    }
    set templateTasks(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get inputFiles() {
        return pb_1.Message.getRepeatedWrapperField(this, InputFile, 15);
    }
    set inputFiles(value) {
        pb_1.Message.setRepeatedWrapperField(this, 15, value);
    }
    static fromObject(data) {
        const message = new RescaleJobAnalysis({});
        if (data.envVars != null) {
            message.envVars = EnvVars.fromObject(data.envVars);
        }
        if (data.useRescaleLicense != null) {
            message.useRescaleLicense = data.useRescaleLicense;
        }
        if (data.onDemandLicenseSeller != null) {
            message.onDemandLicenseSeller = data.onDemandLicenseSeller;
        }
        if (data.userDefinedLicenseSettings != null) {
            message.userDefinedLicenseSettings = UserDefinedLicenseSettings.fromObject(data.userDefinedLicenseSettings);
        }
        if (data.analysis != null) {
            message.analysis = Analysis.fromObject(data.analysis);
        }
        if (data.command != null) {
            message.command = data.command;
        }
        if (data.flags != null) {
            message.flags = Flags.fromObject(data.flags);
        }
        if (data.hardware != null) {
            message.hardware = Hardware.fromObject(data.hardware);
        }
        if (data.inputFolders != null) {
            message.inputFolders = data.inputFolders;
        }
        if (data.postProcessScript != null) {
            message.postProcessScript = data.postProcessScript;
        }
        if (data.postProcessScriptCommand != null) {
            message.postProcessScriptCommand = data.postProcessScriptCommand;
        }
        if (data.preProcessScript != null) {
            message.preProcessScript = data.preProcessScript;
        }
        if (data.preProcessScriptCommand != null) {
            message.preProcessScriptCommand = data.preProcessScriptCommand;
        }
        if (data.templateTasks != null) {
            message.templateTasks = data.templateTasks;
        }
        if (data.inputFiles != null) {
            message.inputFiles = data.inputFiles.map(item => InputFile.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.envVars != null) {
            data.envVars = this.envVars.toObject();
        }
        if (this.useRescaleLicense != null) {
            data.useRescaleLicense = this.useRescaleLicense;
        }
        if (this.onDemandLicenseSeller != null) {
            data.onDemandLicenseSeller = this.onDemandLicenseSeller;
        }
        if (this.userDefinedLicenseSettings != null) {
            data.userDefinedLicenseSettings = this.userDefinedLicenseSettings.toObject();
        }
        if (this.analysis != null) {
            data.analysis = this.analysis.toObject();
        }
        if (this.command != null) {
            data.command = this.command;
        }
        if (this.flags != null) {
            data.flags = this.flags.toObject();
        }
        if (this.hardware != null) {
            data.hardware = this.hardware.toObject();
        }
        if (this.inputFolders != null) {
            data.inputFolders = this.inputFolders;
        }
        if (this.postProcessScript != null) {
            data.postProcessScript = this.postProcessScript;
        }
        if (this.postProcessScriptCommand != null) {
            data.postProcessScriptCommand = this.postProcessScriptCommand;
        }
        if (this.preProcessScript != null) {
            data.preProcessScript = this.preProcessScript;
        }
        if (this.preProcessScriptCommand != null) {
            data.preProcessScriptCommand = this.preProcessScriptCommand;
        }
        if (this.templateTasks != null) {
            data.templateTasks = this.templateTasks;
        }
        if (this.inputFiles != null) {
            data.inputFiles = this.inputFiles.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_envVars)
            writer.writeMessage(1, this.envVars, () => this.envVars.serialize(writer));
        if (this.useRescaleLicense != false)
            writer.writeBool(2, this.useRescaleLicense);
        if (this.onDemandLicenseSeller.length)
            writer.writeString(3, this.onDemandLicenseSeller);
        if (this.has_userDefinedLicenseSettings)
            writer.writeMessage(4, this.userDefinedLicenseSettings, () => this.userDefinedLicenseSettings.serialize(writer));
        if (this.has_analysis)
            writer.writeMessage(5, this.analysis, () => this.analysis.serialize(writer));
        if (this.command.length)
            writer.writeString(6, this.command);
        if (this.has_flags)
            writer.writeMessage(7, this.flags, () => this.flags.serialize(writer));
        if (this.has_hardware)
            writer.writeMessage(8, this.hardware, () => this.hardware.serialize(writer));
        if (this.inputFolders.length)
            writer.writeRepeatedString(9, this.inputFolders);
        if (this.postProcessScript.length)
            writer.writeString(10, this.postProcessScript);
        if (this.postProcessScriptCommand.length)
            writer.writeString(11, this.postProcessScriptCommand);
        if (this.preProcessScript.length)
            writer.writeString(12, this.preProcessScript);
        if (this.preProcessScriptCommand.length)
            writer.writeString(13, this.preProcessScriptCommand);
        if (this.templateTasks.length)
            writer.writeRepeatedString(14, this.templateTasks);
        if (this.inputFiles.length)
            writer.writeRepeatedMessage(15, this.inputFiles, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobAnalysis();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.envVars, () => message.envVars = EnvVars.deserialize(reader));
                    break;
                case 2:
                    message.useRescaleLicense = reader.readBool();
                    break;
                case 3:
                    message.onDemandLicenseSeller = reader.readString();
                    break;
                case 4:
                    reader.readMessage(message.userDefinedLicenseSettings, () => message.userDefinedLicenseSettings = UserDefinedLicenseSettings.deserialize(reader));
                    break;
                case 5:
                    reader.readMessage(message.analysis, () => message.analysis = Analysis.deserialize(reader));
                    break;
                case 6:
                    message.command = reader.readString();
                    break;
                case 7:
                    reader.readMessage(message.flags, () => message.flags = Flags.deserialize(reader));
                    break;
                case 8:
                    reader.readMessage(message.hardware, () => message.hardware = Hardware.deserialize(reader));
                    break;
                case 9:
                    pb_1.Message.addToRepeatedField(message, 9, reader.readString());
                    break;
                case 10:
                    message.postProcessScript = reader.readString();
                    break;
                case 11:
                    message.postProcessScriptCommand = reader.readString();
                    break;
                case 12:
                    message.preProcessScript = reader.readString();
                    break;
                case 13:
                    message.preProcessScriptCommand = reader.readString();
                    break;
                case 14:
                    pb_1.Message.addToRepeatedField(message, 14, reader.readString());
                    break;
                case 15:
                    reader.readMessage(message.inputFiles, () => pb_1.Message.addToRepeatedWrapperField(message, 15, InputFile.deserialize(reader), InputFile));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobAnalysis.deserialize(bytes);
    }
}
exports.RescaleJobAnalysis = RescaleJobAnalysis;
_RescaleJobAnalysis_one_of_decls = new WeakMap();
class RescaleJobAnalysisWH extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobAnalysisWH_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [9, 14, 15], __classPrivateFieldGet(this, _RescaleJobAnalysisWH_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("envVars" in data && data.envVars != undefined) {
                this.envVars = data.envVars;
            }
            if ("useRescaleLicense" in data && data.useRescaleLicense != undefined) {
                this.useRescaleLicense = data.useRescaleLicense;
            }
            if ("onDemandLicenseSeller" in data && data.onDemandLicenseSeller != undefined) {
                this.onDemandLicenseSeller = data.onDemandLicenseSeller;
            }
            if ("userDefinedLicenseSettings" in data && data.userDefinedLicenseSettings != undefined) {
                this.userDefinedLicenseSettings = data.userDefinedLicenseSettings;
            }
            if ("analysis" in data && data.analysis != undefined) {
                this.analysis = data.analysis;
            }
            if ("command" in data && data.command != undefined) {
                this.command = data.command;
            }
            if ("flags" in data && data.flags != undefined) {
                this.flags = data.flags;
            }
            if ("hardware" in data && data.hardware != undefined) {
                this.hardware = data.hardware;
            }
            if ("inputFolders" in data && data.inputFolders != undefined) {
                this.inputFolders = data.inputFolders;
            }
            if ("postProcessScript" in data && data.postProcessScript != undefined) {
                this.postProcessScript = data.postProcessScript;
            }
            if ("postProcessScriptCommand" in data && data.postProcessScriptCommand != undefined) {
                this.postProcessScriptCommand = data.postProcessScriptCommand;
            }
            if ("preProcessScript" in data && data.preProcessScript != undefined) {
                this.preProcessScript = data.preProcessScript;
            }
            if ("preProcessScriptCommand" in data && data.preProcessScriptCommand != undefined) {
                this.preProcessScriptCommand = data.preProcessScriptCommand;
            }
            if ("templateTasks" in data && data.templateTasks != undefined) {
                this.templateTasks = data.templateTasks;
            }
            if ("inputFiles" in data && data.inputFiles != undefined) {
                this.inputFiles = data.inputFiles;
            }
        }
    }
    get envVars() {
        return pb_1.Message.getWrapperField(this, EnvVars, 1);
    }
    set envVars(value) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_envVars() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get useRescaleLicense() {
        return pb_1.Message.getFieldWithDefault(this, 2, false);
    }
    set useRescaleLicense(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get onDemandLicenseSeller() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set onDemandLicenseSeller(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get userDefinedLicenseSettings() {
        return pb_1.Message.getWrapperField(this, UserDefinedLicenseSettings, 4);
    }
    set userDefinedLicenseSettings(value) {
        pb_1.Message.setWrapperField(this, 4, value);
    }
    get has_userDefinedLicenseSettings() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get analysis() {
        return pb_1.Message.getWrapperField(this, Analysis, 5);
    }
    set analysis(value) {
        pb_1.Message.setWrapperField(this, 5, value);
    }
    get has_analysis() {
        return pb_1.Message.getField(this, 5) != null;
    }
    get command() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set command(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get flags() {
        return pb_1.Message.getWrapperField(this, Flags, 7);
    }
    set flags(value) {
        pb_1.Message.setWrapperField(this, 7, value);
    }
    get has_flags() {
        return pb_1.Message.getField(this, 7) != null;
    }
    get hardware() {
        return pb_1.Message.getWrapperField(this, HardwareWH, 8);
    }
    set hardware(value) {
        pb_1.Message.setWrapperField(this, 8, value);
    }
    get has_hardware() {
        return pb_1.Message.getField(this, 8) != null;
    }
    get inputFolders() {
        return pb_1.Message.getFieldWithDefault(this, 9, []);
    }
    set inputFolders(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get postProcessScript() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set postProcessScript(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get postProcessScriptCommand() {
        return pb_1.Message.getFieldWithDefault(this, 11, "");
    }
    set postProcessScriptCommand(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get preProcessScript() {
        return pb_1.Message.getFieldWithDefault(this, 12, "");
    }
    set preProcessScript(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get preProcessScriptCommand() {
        return pb_1.Message.getFieldWithDefault(this, 13, "");
    }
    set preProcessScriptCommand(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get templateTasks() {
        return pb_1.Message.getFieldWithDefault(this, 14, []);
    }
    set templateTasks(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get inputFiles() {
        return pb_1.Message.getRepeatedWrapperField(this, InputFile, 15);
    }
    set inputFiles(value) {
        pb_1.Message.setRepeatedWrapperField(this, 15, value);
    }
    static fromObject(data) {
        const message = new RescaleJobAnalysisWH({});
        if (data.envVars != null) {
            message.envVars = EnvVars.fromObject(data.envVars);
        }
        if (data.useRescaleLicense != null) {
            message.useRescaleLicense = data.useRescaleLicense;
        }
        if (data.onDemandLicenseSeller != null) {
            message.onDemandLicenseSeller = data.onDemandLicenseSeller;
        }
        if (data.userDefinedLicenseSettings != null) {
            message.userDefinedLicenseSettings = UserDefinedLicenseSettings.fromObject(data.userDefinedLicenseSettings);
        }
        if (data.analysis != null) {
            message.analysis = Analysis.fromObject(data.analysis);
        }
        if (data.command != null) {
            message.command = data.command;
        }
        if (data.flags != null) {
            message.flags = Flags.fromObject(data.flags);
        }
        if (data.hardware != null) {
            message.hardware = HardwareWH.fromObject(data.hardware);
        }
        if (data.inputFolders != null) {
            message.inputFolders = data.inputFolders;
        }
        if (data.postProcessScript != null) {
            message.postProcessScript = data.postProcessScript;
        }
        if (data.postProcessScriptCommand != null) {
            message.postProcessScriptCommand = data.postProcessScriptCommand;
        }
        if (data.preProcessScript != null) {
            message.preProcessScript = data.preProcessScript;
        }
        if (data.preProcessScriptCommand != null) {
            message.preProcessScriptCommand = data.preProcessScriptCommand;
        }
        if (data.templateTasks != null) {
            message.templateTasks = data.templateTasks;
        }
        if (data.inputFiles != null) {
            message.inputFiles = data.inputFiles.map(item => InputFile.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.envVars != null) {
            data.envVars = this.envVars.toObject();
        }
        if (this.useRescaleLicense != null) {
            data.useRescaleLicense = this.useRescaleLicense;
        }
        if (this.onDemandLicenseSeller != null) {
            data.onDemandLicenseSeller = this.onDemandLicenseSeller;
        }
        if (this.userDefinedLicenseSettings != null) {
            data.userDefinedLicenseSettings = this.userDefinedLicenseSettings.toObject();
        }
        if (this.analysis != null) {
            data.analysis = this.analysis.toObject();
        }
        if (this.command != null) {
            data.command = this.command;
        }
        if (this.flags != null) {
            data.flags = this.flags.toObject();
        }
        if (this.hardware != null) {
            data.hardware = this.hardware.toObject();
        }
        if (this.inputFolders != null) {
            data.inputFolders = this.inputFolders;
        }
        if (this.postProcessScript != null) {
            data.postProcessScript = this.postProcessScript;
        }
        if (this.postProcessScriptCommand != null) {
            data.postProcessScriptCommand = this.postProcessScriptCommand;
        }
        if (this.preProcessScript != null) {
            data.preProcessScript = this.preProcessScript;
        }
        if (this.preProcessScriptCommand != null) {
            data.preProcessScriptCommand = this.preProcessScriptCommand;
        }
        if (this.templateTasks != null) {
            data.templateTasks = this.templateTasks;
        }
        if (this.inputFiles != null) {
            data.inputFiles = this.inputFiles.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_envVars)
            writer.writeMessage(1, this.envVars, () => this.envVars.serialize(writer));
        if (this.useRescaleLicense != false)
            writer.writeBool(2, this.useRescaleLicense);
        if (this.onDemandLicenseSeller.length)
            writer.writeString(3, this.onDemandLicenseSeller);
        if (this.has_userDefinedLicenseSettings)
            writer.writeMessage(4, this.userDefinedLicenseSettings, () => this.userDefinedLicenseSettings.serialize(writer));
        if (this.has_analysis)
            writer.writeMessage(5, this.analysis, () => this.analysis.serialize(writer));
        if (this.command.length)
            writer.writeString(6, this.command);
        if (this.has_flags)
            writer.writeMessage(7, this.flags, () => this.flags.serialize(writer));
        if (this.has_hardware)
            writer.writeMessage(8, this.hardware, () => this.hardware.serialize(writer));
        if (this.inputFolders.length)
            writer.writeRepeatedString(9, this.inputFolders);
        if (this.postProcessScript.length)
            writer.writeString(10, this.postProcessScript);
        if (this.postProcessScriptCommand.length)
            writer.writeString(11, this.postProcessScriptCommand);
        if (this.preProcessScript.length)
            writer.writeString(12, this.preProcessScript);
        if (this.preProcessScriptCommand.length)
            writer.writeString(13, this.preProcessScriptCommand);
        if (this.templateTasks.length)
            writer.writeRepeatedString(14, this.templateTasks);
        if (this.inputFiles.length)
            writer.writeRepeatedMessage(15, this.inputFiles, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobAnalysisWH();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.envVars, () => message.envVars = EnvVars.deserialize(reader));
                    break;
                case 2:
                    message.useRescaleLicense = reader.readBool();
                    break;
                case 3:
                    message.onDemandLicenseSeller = reader.readString();
                    break;
                case 4:
                    reader.readMessage(message.userDefinedLicenseSettings, () => message.userDefinedLicenseSettings = UserDefinedLicenseSettings.deserialize(reader));
                    break;
                case 5:
                    reader.readMessage(message.analysis, () => message.analysis = Analysis.deserialize(reader));
                    break;
                case 6:
                    message.command = reader.readString();
                    break;
                case 7:
                    reader.readMessage(message.flags, () => message.flags = Flags.deserialize(reader));
                    break;
                case 8:
                    reader.readMessage(message.hardware, () => message.hardware = HardwareWH.deserialize(reader));
                    break;
                case 9:
                    pb_1.Message.addToRepeatedField(message, 9, reader.readString());
                    break;
                case 10:
                    message.postProcessScript = reader.readString();
                    break;
                case 11:
                    message.postProcessScriptCommand = reader.readString();
                    break;
                case 12:
                    message.preProcessScript = reader.readString();
                    break;
                case 13:
                    message.preProcessScriptCommand = reader.readString();
                    break;
                case 14:
                    pb_1.Message.addToRepeatedField(message, 14, reader.readString());
                    break;
                case 15:
                    reader.readMessage(message.inputFiles, () => pb_1.Message.addToRepeatedWrapperField(message, 15, InputFile.deserialize(reader), InputFile));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobAnalysisWH.deserialize(bytes);
    }
}
exports.RescaleJobAnalysisWH = RescaleJobAnalysisWH;
_RescaleJobAnalysisWH_one_of_decls = new WeakMap();
class InputFile extends pb_1.Message {
    constructor(data) {
        super();
        _InputFile_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _InputFile_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("dateUploaded" in data && data.dateUploaded != undefined) {
                this.dateUploaded = data.dateUploaded;
            }
            if ("decryptedSize" in data && data.decryptedSize != undefined) {
                this.decryptedSize = data.decryptedSize;
            }
            if ("id" in data && data.id != undefined) {
                this.id = data.id;
            }
            if ("isUploaded" in data && data.isUploaded != undefined) {
                this.isUploaded = data.isUploaded;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("owner" in data && data.owner != undefined) {
                this.owner = data.owner;
            }
            if ("path" in data && data.path != undefined) {
                this.path = data.path;
            }
            if ("relativePath" in data && data.relativePath != undefined) {
                this.relativePath = data.relativePath;
            }
            if ("pathParts" in data && data.pathParts != undefined) {
                this.pathParts = data.pathParts;
            }
        }
    }
    get dateUploaded() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set dateUploaded(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get decryptedSize() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set decryptedSize(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get id() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set id(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get isUploaded() {
        return pb_1.Message.getFieldWithDefault(this, 4, false);
    }
    set isUploaded(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get owner() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set owner(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get path() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set path(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get relativePath() {
        return pb_1.Message.getFieldWithDefault(this, 8, "");
    }
    set relativePath(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get pathParts() {
        return pb_1.Message.getWrapperField(this, PathParts, 9);
    }
    set pathParts(value) {
        pb_1.Message.setWrapperField(this, 9, value);
    }
    get has_pathParts() {
        return pb_1.Message.getField(this, 9) != null;
    }
    static fromObject(data) {
        const message = new InputFile({});
        if (data.dateUploaded != null) {
            message.dateUploaded = data.dateUploaded;
        }
        if (data.decryptedSize != null) {
            message.decryptedSize = data.decryptedSize;
        }
        if (data.id != null) {
            message.id = data.id;
        }
        if (data.isUploaded != null) {
            message.isUploaded = data.isUploaded;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.owner != null) {
            message.owner = data.owner;
        }
        if (data.path != null) {
            message.path = data.path;
        }
        if (data.relativePath != null) {
            message.relativePath = data.relativePath;
        }
        if (data.pathParts != null) {
            message.pathParts = PathParts.fromObject(data.pathParts);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.dateUploaded != null) {
            data.dateUploaded = this.dateUploaded;
        }
        if (this.decryptedSize != null) {
            data.decryptedSize = this.decryptedSize;
        }
        if (this.id != null) {
            data.id = this.id;
        }
        if (this.isUploaded != null) {
            data.isUploaded = this.isUploaded;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.owner != null) {
            data.owner = this.owner;
        }
        if (this.path != null) {
            data.path = this.path;
        }
        if (this.relativePath != null) {
            data.relativePath = this.relativePath;
        }
        if (this.pathParts != null) {
            data.pathParts = this.pathParts.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.dateUploaded.length)
            writer.writeString(1, this.dateUploaded);
        if (this.decryptedSize != 0)
            writer.writeInt32(2, this.decryptedSize);
        if (this.id.length)
            writer.writeString(3, this.id);
        if (this.isUploaded != false)
            writer.writeBool(4, this.isUploaded);
        if (this.name.length)
            writer.writeString(5, this.name);
        if (this.owner.length)
            writer.writeString(6, this.owner);
        if (this.path.length)
            writer.writeString(7, this.path);
        if (this.relativePath.length)
            writer.writeString(8, this.relativePath);
        if (this.has_pathParts)
            writer.writeMessage(9, this.pathParts, () => this.pathParts.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new InputFile();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.dateUploaded = reader.readString();
                    break;
                case 2:
                    message.decryptedSize = reader.readInt32();
                    break;
                case 3:
                    message.id = reader.readString();
                    break;
                case 4:
                    message.isUploaded = reader.readBool();
                    break;
                case 5:
                    message.name = reader.readString();
                    break;
                case 6:
                    message.owner = reader.readString();
                    break;
                case 7:
                    message.path = reader.readString();
                    break;
                case 8:
                    message.relativePath = reader.readString();
                    break;
                case 9:
                    reader.readMessage(message.pathParts, () => message.pathParts = PathParts.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return InputFile.deserialize(bytes);
    }
}
exports.InputFile = InputFile;
_InputFile_one_of_decls = new WeakMap();
class PathParts extends pb_1.Message {
    constructor(data) {
        super();
        _PathParts_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _PathParts_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("container" in data && data.container != undefined) {
                this.container = data.container;
            }
            if ("path" in data && data.path != undefined) {
                this.path = data.path;
            }
        }
    }
    get container() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set container(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get path() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set path(value) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data) {
        const message = new PathParts({});
        if (data.container != null) {
            message.container = data.container;
        }
        if (data.path != null) {
            message.path = data.path;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.container != null) {
            data.container = this.container;
        }
        if (this.path != null) {
            data.path = this.path;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.container.length)
            writer.writeString(1, this.container);
        if (this.path.length)
            writer.writeString(2, this.path);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PathParts();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.container = reader.readString();
                    break;
                case 2:
                    message.path = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return PathParts.deserialize(bytes);
    }
}
exports.PathParts = PathParts;
_PathParts_one_of_decls = new WeakMap();
class EnvVars extends pb_1.Message {
    constructor(data) {
        super();
        _EnvVars_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _EnvVars_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("LM_PROJECT" in data && data.LM_PROJECT != undefined) {
                this.LM_PROJECT = data.LM_PROJECT;
            }
            if ("CDLMD_LICENSE_FILE" in data && data.CDLMD_LICENSE_FILE != undefined) {
                this.CDLMD_LICENSE_FILE = data.CDLMD_LICENSE_FILE;
            }
            if ("RESCALE_ARTDIST_META_URL" in data && data.RESCALE_ARTDIST_META_URL != undefined) {
                this.RESCALE_ARTDIST_META_URL = data.RESCALE_ARTDIST_META_URL;
            }
            if ("RESCALE_ARTDIST_MOUNTPOINT" in data && data.RESCALE_ARTDIST_MOUNTPOINT != undefined) {
                this.RESCALE_ARTDIST_MOUNTPOINT = data.RESCALE_ARTDIST_MOUNTPOINT;
            }
            if ("RESCALE_ARTDIST_META_REGION" in data && data.RESCALE_ARTDIST_META_REGION != undefined) {
                this.RESCALE_ARTDIST_META_REGION = data.RESCALE_ARTDIST_META_REGION;
            }
            if ("AERO_PROCESS_ID" in data && data.AERO_PROCESS_ID != undefined) {
                this.AERO_PROCESS_ID = data.AERO_PROCESS_ID;
            }
        }
    }
    get LM_PROJECT() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set LM_PROJECT(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get CDLMD_LICENSE_FILE() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set CDLMD_LICENSE_FILE(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get RESCALE_ARTDIST_META_URL() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set RESCALE_ARTDIST_META_URL(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get RESCALE_ARTDIST_MOUNTPOINT() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set RESCALE_ARTDIST_MOUNTPOINT(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get RESCALE_ARTDIST_META_REGION() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set RESCALE_ARTDIST_META_REGION(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get AERO_PROCESS_ID() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set AERO_PROCESS_ID(value) {
        pb_1.Message.setField(this, 6, value);
    }
    static fromObject(data) {
        const message = new EnvVars({});
        if (data.LM_PROJECT != null) {
            message.LM_PROJECT = data.LM_PROJECT;
        }
        if (data.CDLMD_LICENSE_FILE != null) {
            message.CDLMD_LICENSE_FILE = data.CDLMD_LICENSE_FILE;
        }
        if (data.RESCALE_ARTDIST_META_URL != null) {
            message.RESCALE_ARTDIST_META_URL = data.RESCALE_ARTDIST_META_URL;
        }
        if (data.RESCALE_ARTDIST_MOUNTPOINT != null) {
            message.RESCALE_ARTDIST_MOUNTPOINT = data.RESCALE_ARTDIST_MOUNTPOINT;
        }
        if (data.RESCALE_ARTDIST_META_REGION != null) {
            message.RESCALE_ARTDIST_META_REGION = data.RESCALE_ARTDIST_META_REGION;
        }
        if (data.AERO_PROCESS_ID != null) {
            message.AERO_PROCESS_ID = data.AERO_PROCESS_ID;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.LM_PROJECT != null) {
            data.LM_PROJECT = this.LM_PROJECT;
        }
        if (this.CDLMD_LICENSE_FILE != null) {
            data.CDLMD_LICENSE_FILE = this.CDLMD_LICENSE_FILE;
        }
        if (this.RESCALE_ARTDIST_META_URL != null) {
            data.RESCALE_ARTDIST_META_URL = this.RESCALE_ARTDIST_META_URL;
        }
        if (this.RESCALE_ARTDIST_MOUNTPOINT != null) {
            data.RESCALE_ARTDIST_MOUNTPOINT = this.RESCALE_ARTDIST_MOUNTPOINT;
        }
        if (this.RESCALE_ARTDIST_META_REGION != null) {
            data.RESCALE_ARTDIST_META_REGION = this.RESCALE_ARTDIST_META_REGION;
        }
        if (this.AERO_PROCESS_ID != null) {
            data.AERO_PROCESS_ID = this.AERO_PROCESS_ID;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.LM_PROJECT.length)
            writer.writeString(1, this.LM_PROJECT);
        if (this.CDLMD_LICENSE_FILE.length)
            writer.writeString(2, this.CDLMD_LICENSE_FILE);
        if (this.RESCALE_ARTDIST_META_URL.length)
            writer.writeString(3, this.RESCALE_ARTDIST_META_URL);
        if (this.RESCALE_ARTDIST_MOUNTPOINT.length)
            writer.writeString(4, this.RESCALE_ARTDIST_MOUNTPOINT);
        if (this.RESCALE_ARTDIST_META_REGION.length)
            writer.writeString(5, this.RESCALE_ARTDIST_META_REGION);
        if (this.AERO_PROCESS_ID.length)
            writer.writeString(6, this.AERO_PROCESS_ID);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new EnvVars();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.LM_PROJECT = reader.readString();
                    break;
                case 2:
                    message.CDLMD_LICENSE_FILE = reader.readString();
                    break;
                case 3:
                    message.RESCALE_ARTDIST_META_URL = reader.readString();
                    break;
                case 4:
                    message.RESCALE_ARTDIST_MOUNTPOINT = reader.readString();
                    break;
                case 5:
                    message.RESCALE_ARTDIST_META_REGION = reader.readString();
                    break;
                case 6:
                    message.AERO_PROCESS_ID = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return EnvVars.deserialize(bytes);
    }
}
exports.EnvVars = EnvVars;
_EnvVars_one_of_decls = new WeakMap();
class Analysis extends pb_1.Message {
    constructor(data) {
        super();
        _Analysis_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Analysis_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("code" in data && data.code != undefined) {
                this.code = data.code;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("version" in data && data.version != undefined) {
                this.version = data.version;
            }
            if ("versionName" in data && data.versionName != undefined) {
                this.versionName = data.versionName;
            }
            if ("thumbnail" in data && data.thumbnail != undefined) {
                this.thumbnail = data.thumbnail;
            }
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
            if ("osFamily" in data && data.osFamily != undefined) {
                this.osFamily = data.osFamily;
            }
        }
    }
    get code() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set code(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get version() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set version(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get versionName() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set versionName(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get thumbnail() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set thumbnail(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set type(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get osFamily() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set osFamily(value) {
        pb_1.Message.setField(this, 7, value);
    }
    static fromObject(data) {
        const message = new Analysis({});
        if (data.code != null) {
            message.code = data.code;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.version != null) {
            message.version = data.version;
        }
        if (data.versionName != null) {
            message.versionName = data.versionName;
        }
        if (data.thumbnail != null) {
            message.thumbnail = data.thumbnail;
        }
        if (data.type != null) {
            message.type = data.type;
        }
        if (data.osFamily != null) {
            message.osFamily = data.osFamily;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.code != null) {
            data.code = this.code;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.version != null) {
            data.version = this.version;
        }
        if (this.versionName != null) {
            data.versionName = this.versionName;
        }
        if (this.thumbnail != null) {
            data.thumbnail = this.thumbnail;
        }
        if (this.type != null) {
            data.type = this.type;
        }
        if (this.osFamily != null) {
            data.osFamily = this.osFamily;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.code.length)
            writer.writeString(1, this.code);
        if (this.name.length)
            writer.writeString(2, this.name);
        if (this.version.length)
            writer.writeString(3, this.version);
        if (this.versionName.length)
            writer.writeString(4, this.versionName);
        if (this.thumbnail.length)
            writer.writeString(5, this.thumbnail);
        if (this.type.length)
            writer.writeString(6, this.type);
        if (this.osFamily.length)
            writer.writeString(7, this.osFamily);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Analysis();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.code = reader.readString();
                    break;
                case 2:
                    message.name = reader.readString();
                    break;
                case 3:
                    message.version = reader.readString();
                    break;
                case 4:
                    message.versionName = reader.readString();
                    break;
                case 5:
                    message.thumbnail = reader.readString();
                    break;
                case 6:
                    message.type = reader.readString();
                    break;
                case 7:
                    message.osFamily = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Analysis.deserialize(bytes);
    }
}
exports.Analysis = Analysis;
_Analysis_one_of_decls = new WeakMap();
class Flags extends pb_1.Message {
    constructor(data) {
        super();
        _Flags_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Flags_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("runForever" in data && data.runForever != undefined) {
                this.runForever = data.runForever;
            }
            if ("igCv" in data && data.igCv != undefined) {
                this.igCv = data.igCv;
            }
        }
    }
    get runForever() {
        return pb_1.Message.getFieldWithDefault(this, 1, false);
    }
    set runForever(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get igCv() {
        return pb_1.Message.getFieldWithDefault(this, 2, false);
    }
    set igCv(value) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data) {
        const message = new Flags({});
        if (data.runForever != null) {
            message.runForever = data.runForever;
        }
        if (data.igCv != null) {
            message.igCv = data.igCv;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.runForever != null) {
            data.runForever = this.runForever;
        }
        if (this.igCv != null) {
            data.igCv = this.igCv;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.runForever != false)
            writer.writeBool(1, this.runForever);
        if (this.igCv != false)
            writer.writeBool(2, this.igCv);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Flags();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.runForever = reader.readBool();
                    break;
                case 2:
                    message.igCv = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Flags.deserialize(bytes);
    }
}
exports.Flags = Flags;
_Flags_one_of_decls = new WeakMap();
class HardwareWH extends pb_1.Message {
    constructor(data) {
        super();
        _HardwareWH_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _HardwareWH_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("slots" in data && data.slots != undefined) {
                this.slots = data.slots;
            }
            if ("coresPerSlot" in data && data.coresPerSlot != undefined) {
                this.coresPerSlot = data.coresPerSlot;
            }
            if ("coreType" in data && data.coreType != undefined) {
                this.coreType = data.coreType;
            }
            if ("coreSummary" in data && data.coreSummary != undefined) {
                this.coreSummary = data.coreSummary;
            }
            if ("walltime" in data && data.walltime != undefined) {
                this.walltime = data.walltime;
            }
            if ("coreClass" in data && data.coreClass != undefined) {
                this.coreClass = data.coreClass;
            }
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
            if ("scheduler" in data && data.scheduler != undefined) {
                this.scheduler = data.scheduler;
            }
            if ("rceConnector" in data && data.rceConnector != undefined) {
                this.rceConnector = data.rceConnector;
            }
            if ("autosuspend" in data && data.autosuspend != undefined) {
                this.autosuspend = data.autosuspend;
            }
            if ("instanceType" in data && data.instanceType != undefined) {
                this.instanceType = data.instanceType;
            }
            if ("isReusable" in data && data.isReusable != undefined) {
                this.isReusable = data.isReusable;
            }
        }
    }
    get slots() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set slots(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get coresPerSlot() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set coresPerSlot(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get coreType() {
        return pb_1.Message.getWrapperField(this, CoreType, 3);
    }
    set coreType(value) {
        pb_1.Message.setWrapperField(this, 3, value);
    }
    get has_coreType() {
        return pb_1.Message.getField(this, 3) != null;
    }
    get coreSummary() {
        return pb_1.Message.getWrapperField(this, CoreSummary, 4);
    }
    set coreSummary(value) {
        pb_1.Message.setWrapperField(this, 4, value);
    }
    get has_coreSummary() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get walltime() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set walltime(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get coreClass() {
        return pb_1.Message.getFieldWithDefault(this, 6, "");
    }
    set coreClass(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set type(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get scheduler() {
        return pb_1.Message.getWrapperField(this, Scheduler, 8);
    }
    set scheduler(value) {
        pb_1.Message.setWrapperField(this, 8, value);
    }
    get has_scheduler() {
        return pb_1.Message.getField(this, 8) != null;
    }
    get rceConnector() {
        return pb_1.Message.getWrapperField(this, RceConnector, 9);
    }
    set rceConnector(value) {
        pb_1.Message.setWrapperField(this, 9, value);
    }
    get has_rceConnector() {
        return pb_1.Message.getField(this, 9) != null;
    }
    get autosuspend() {
        return pb_1.Message.getFieldWithDefault(this, 10, false);
    }
    set autosuspend(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get instanceType() {
        return pb_1.Message.getWrapperField(this, InstanceType, 11);
    }
    set instanceType(value) {
        pb_1.Message.setWrapperField(this, 11, value);
    }
    get has_instanceType() {
        return pb_1.Message.getField(this, 11) != null;
    }
    get isReusable() {
        return pb_1.Message.getFieldWithDefault(this, 12, false);
    }
    set isReusable(value) {
        pb_1.Message.setField(this, 12, value);
    }
    static fromObject(data) {
        const message = new HardwareWH({});
        if (data.slots != null) {
            message.slots = data.slots;
        }
        if (data.coresPerSlot != null) {
            message.coresPerSlot = data.coresPerSlot;
        }
        if (data.coreType != null) {
            message.coreType = CoreType.fromObject(data.coreType);
        }
        if (data.coreSummary != null) {
            message.coreSummary = CoreSummary.fromObject(data.coreSummary);
        }
        if (data.walltime != null) {
            message.walltime = data.walltime;
        }
        if (data.coreClass != null) {
            message.coreClass = data.coreClass;
        }
        if (data.type != null) {
            message.type = data.type;
        }
        if (data.scheduler != null) {
            message.scheduler = Scheduler.fromObject(data.scheduler);
        }
        if (data.rceConnector != null) {
            message.rceConnector = RceConnector.fromObject(data.rceConnector);
        }
        if (data.autosuspend != null) {
            message.autosuspend = data.autosuspend;
        }
        if (data.instanceType != null) {
            message.instanceType = InstanceType.fromObject(data.instanceType);
        }
        if (data.isReusable != null) {
            message.isReusable = data.isReusable;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.slots != null) {
            data.slots = this.slots;
        }
        if (this.coresPerSlot != null) {
            data.coresPerSlot = this.coresPerSlot;
        }
        if (this.coreType != null) {
            data.coreType = this.coreType.toObject();
        }
        if (this.coreSummary != null) {
            data.coreSummary = this.coreSummary.toObject();
        }
        if (this.walltime != null) {
            data.walltime = this.walltime;
        }
        if (this.coreClass != null) {
            data.coreClass = this.coreClass;
        }
        if (this.type != null) {
            data.type = this.type;
        }
        if (this.scheduler != null) {
            data.scheduler = this.scheduler.toObject();
        }
        if (this.rceConnector != null) {
            data.rceConnector = this.rceConnector.toObject();
        }
        if (this.autosuspend != null) {
            data.autosuspend = this.autosuspend;
        }
        if (this.instanceType != null) {
            data.instanceType = this.instanceType.toObject();
        }
        if (this.isReusable != null) {
            data.isReusable = this.isReusable;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.slots != 0)
            writer.writeUint32(1, this.slots);
        if (this.coresPerSlot != 0)
            writer.writeUint32(2, this.coresPerSlot);
        if (this.has_coreType)
            writer.writeMessage(3, this.coreType, () => this.coreType.serialize(writer));
        if (this.has_coreSummary)
            writer.writeMessage(4, this.coreSummary, () => this.coreSummary.serialize(writer));
        if (this.walltime != 0)
            writer.writeUint32(5, this.walltime);
        if (this.coreClass.length)
            writer.writeString(6, this.coreClass);
        if (this.type.length)
            writer.writeString(7, this.type);
        if (this.has_scheduler)
            writer.writeMessage(8, this.scheduler, () => this.scheduler.serialize(writer));
        if (this.has_rceConnector)
            writer.writeMessage(9, this.rceConnector, () => this.rceConnector.serialize(writer));
        if (this.autosuspend != false)
            writer.writeBool(10, this.autosuspend);
        if (this.has_instanceType)
            writer.writeMessage(11, this.instanceType, () => this.instanceType.serialize(writer));
        if (this.isReusable != false)
            writer.writeBool(12, this.isReusable);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new HardwareWH();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.slots = reader.readUint32();
                    break;
                case 2:
                    message.coresPerSlot = reader.readUint32();
                    break;
                case 3:
                    reader.readMessage(message.coreType, () => message.coreType = CoreType.deserialize(reader));
                    break;
                case 4:
                    reader.readMessage(message.coreSummary, () => message.coreSummary = CoreSummary.deserialize(reader));
                    break;
                case 5:
                    message.walltime = reader.readUint32();
                    break;
                case 6:
                    message.coreClass = reader.readString();
                    break;
                case 7:
                    message.type = reader.readString();
                    break;
                case 8:
                    reader.readMessage(message.scheduler, () => message.scheduler = Scheduler.deserialize(reader));
                    break;
                case 9:
                    reader.readMessage(message.rceConnector, () => message.rceConnector = RceConnector.deserialize(reader));
                    break;
                case 10:
                    message.autosuspend = reader.readBool();
                    break;
                case 11:
                    reader.readMessage(message.instanceType, () => message.instanceType = InstanceType.deserialize(reader));
                    break;
                case 12:
                    message.isReusable = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return HardwareWH.deserialize(bytes);
    }
}
exports.HardwareWH = HardwareWH;
_HardwareWH_one_of_decls = new WeakMap();
class Hardware extends pb_1.Message {
    constructor(data) {
        super();
        _Hardware_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Hardware_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("slots" in data && data.slots != undefined) {
                this.slots = data.slots;
            }
            if ("coresPerSlot" in data && data.coresPerSlot != undefined) {
                this.coresPerSlot = data.coresPerSlot;
            }
            if ("coreType" in data && data.coreType != undefined) {
                this.coreType = data.coreType;
            }
            if ("coreSummary" in data && data.coreSummary != undefined) {
                this.coreSummary = data.coreSummary;
            }
            if ("walltime" in data && data.walltime != undefined) {
                this.walltime = data.walltime;
            }
        }
    }
    get slots() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set slots(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get coresPerSlot() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set coresPerSlot(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get coreType() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set coreType(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get coreSummary() {
        return pb_1.Message.getWrapperField(this, CoreSummary, 4);
    }
    set coreSummary(value) {
        pb_1.Message.setWrapperField(this, 4, value);
    }
    get has_coreSummary() {
        return pb_1.Message.getField(this, 4) != null;
    }
    get walltime() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0);
    }
    set walltime(value) {
        pb_1.Message.setField(this, 5, value);
    }
    static fromObject(data) {
        const message = new Hardware({});
        if (data.slots != null) {
            message.slots = data.slots;
        }
        if (data.coresPerSlot != null) {
            message.coresPerSlot = data.coresPerSlot;
        }
        if (data.coreType != null) {
            message.coreType = data.coreType;
        }
        if (data.coreSummary != null) {
            message.coreSummary = CoreSummary.fromObject(data.coreSummary);
        }
        if (data.walltime != null) {
            message.walltime = data.walltime;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.slots != null) {
            data.slots = this.slots;
        }
        if (this.coresPerSlot != null) {
            data.coresPerSlot = this.coresPerSlot;
        }
        if (this.coreType != null) {
            data.coreType = this.coreType;
        }
        if (this.coreSummary != null) {
            data.coreSummary = this.coreSummary.toObject();
        }
        if (this.walltime != null) {
            data.walltime = this.walltime;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.slots != 0)
            writer.writeInt32(1, this.slots);
        if (this.coresPerSlot != 0)
            writer.writeInt32(2, this.coresPerSlot);
        if (this.coreType.length)
            writer.writeString(3, this.coreType);
        if (this.has_coreSummary)
            writer.writeMessage(4, this.coreSummary, () => this.coreSummary.serialize(writer));
        if (this.walltime != 0)
            writer.writeInt32(5, this.walltime);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Hardware();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.slots = reader.readInt32();
                    break;
                case 2:
                    message.coresPerSlot = reader.readInt32();
                    break;
                case 3:
                    message.coreType = reader.readString();
                    break;
                case 4:
                    reader.readMessage(message.coreSummary, () => message.coreSummary = CoreSummary.deserialize(reader));
                    break;
                case 5:
                    message.walltime = reader.readInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Hardware.deserialize(bytes);
    }
}
exports.Hardware = Hardware;
_Hardware_one_of_decls = new WeakMap();
class RceConnector extends pb_1.Message {
    constructor(data) {
        super();
        _RceConnector_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RceConnector_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data) {
        const message = new RceConnector({});
        return message;
    }
    toObject() {
        const data = {};
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RceConnector();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RceConnector.deserialize(bytes);
    }
}
exports.RceConnector = RceConnector;
_RceConnector_one_of_decls = new WeakMap();
class CoreSummary extends pb_1.Message {
    constructor(data) {
        super();
        _CoreSummary_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _CoreSummary_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("numberOfNodes" in data && data.numberOfNodes != undefined) {
                this.numberOfNodes = data.numberOfNodes;
            }
            if ("memoryPerNode" in data && data.memoryPerNode != undefined) {
                this.memoryPerNode = data.memoryPerNode;
            }
            if ("storagePerNode" in data && data.storagePerNode != undefined) {
                this.storagePerNode = data.storagePerNode;
            }
            if ("gpusPerNode" in data && data.gpusPerNode != undefined) {
                this.gpusPerNode = data.gpusPerNode;
            }
        }
    }
    get numberOfNodes() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set numberOfNodes(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get memoryPerNode() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set memoryPerNode(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get storagePerNode() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0);
    }
    set storagePerNode(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get gpusPerNode() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set gpusPerNode(value) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data) {
        const message = new CoreSummary({});
        if (data.numberOfNodes != null) {
            message.numberOfNodes = data.numberOfNodes;
        }
        if (data.memoryPerNode != null) {
            message.memoryPerNode = data.memoryPerNode;
        }
        if (data.storagePerNode != null) {
            message.storagePerNode = data.storagePerNode;
        }
        if (data.gpusPerNode != null) {
            message.gpusPerNode = data.gpusPerNode;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.numberOfNodes != null) {
            data.numberOfNodes = this.numberOfNodes;
        }
        if (this.memoryPerNode != null) {
            data.memoryPerNode = this.memoryPerNode;
        }
        if (this.storagePerNode != null) {
            data.storagePerNode = this.storagePerNode;
        }
        if (this.gpusPerNode != null) {
            data.gpusPerNode = this.gpusPerNode;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.numberOfNodes != 0)
            writer.writeFloat(1, this.numberOfNodes);
        if (this.memoryPerNode != 0)
            writer.writeFloat(2, this.memoryPerNode);
        if (this.storagePerNode != 0)
            writer.writeUint32(3, this.storagePerNode);
        if (this.gpusPerNode != 0)
            writer.writeFloat(4, this.gpusPerNode);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CoreSummary();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.numberOfNodes = reader.readFloat();
                    break;
                case 2:
                    message.memoryPerNode = reader.readFloat();
                    break;
                case 3:
                    message.storagePerNode = reader.readUint32();
                    break;
                case 4:
                    message.gpusPerNode = reader.readFloat();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return CoreSummary.deserialize(bytes);
    }
}
exports.CoreSummary = CoreSummary;
_CoreSummary_one_of_decls = new WeakMap();
class Scheduler extends pb_1.Message {
    constructor(data) {
        super();
        _Scheduler_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Scheduler_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") { }
    }
    static fromObject(data) {
        const message = new Scheduler({});
        return message;
    }
    toObject() {
        const data = {};
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Scheduler();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return Scheduler.deserialize(bytes);
    }
}
exports.Scheduler = Scheduler;
_Scheduler_one_of_decls = new WeakMap();
class InstanceType extends pb_1.Message {
    constructor(data) {
        super();
        _InstanceType_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _InstanceType_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("apiName" in data && data.apiName != undefined) {
                this.apiName = data.apiName;
            }
        }
    }
    get apiName() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set apiName(value) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data) {
        const message = new InstanceType({});
        if (data.apiName != null) {
            message.apiName = data.apiName;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.apiName != null) {
            data.apiName = this.apiName;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.apiName.length)
            writer.writeString(1, this.apiName);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new InstanceType();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.apiName = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return InstanceType.deserialize(bytes);
    }
}
exports.InstanceType = InstanceType;
_InstanceType_one_of_decls = new WeakMap();
class UserDefinedLicenseSettings extends pb_1.Message {
    constructor(data) {
        super();
        _UserDefinedLicenseSettings_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], __classPrivateFieldGet(this, _UserDefinedLicenseSettings_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("featureSets" in data && data.featureSets != undefined) {
                this.featureSets = data.featureSets;
            }
        }
    }
    get featureSets() {
        return pb_1.Message.getRepeatedWrapperField(this, FeatureSet, 1);
    }
    set featureSets(value) {
        pb_1.Message.setRepeatedWrapperField(this, 1, value);
    }
    static fromObject(data) {
        const message = new UserDefinedLicenseSettings({});
        if (data.featureSets != null) {
            message.featureSets = data.featureSets.map(item => FeatureSet.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.featureSets != null) {
            data.featureSets = this.featureSets.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.featureSets.length)
            writer.writeRepeatedMessage(1, this.featureSets, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UserDefinedLicenseSettings();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.featureSets, () => pb_1.Message.addToRepeatedWrapperField(message, 1, FeatureSet.deserialize(reader), FeatureSet));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return UserDefinedLicenseSettings.deserialize(bytes);
    }
}
exports.UserDefinedLicenseSettings = UserDefinedLicenseSettings;
_UserDefinedLicenseSettings_one_of_decls = new WeakMap();
class FeatureSet extends pb_1.Message {
    constructor(data) {
        super();
        _FeatureSet_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], __classPrivateFieldGet(this, _FeatureSet_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("features" in data && data.features != undefined) {
                this.features = data.features;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get features() {
        return pb_1.Message.getRepeatedWrapperField(this, StarCCMFeature, 2);
    }
    set features(value) {
        pb_1.Message.setRepeatedWrapperField(this, 2, value);
    }
    static fromObject(data) {
        const message = new FeatureSet({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.features != null) {
            message.features = data.features.map(item => StarCCMFeature.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.features != null) {
            data.features = this.features.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.features.length)
            writer.writeRepeatedMessage(2, this.features, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new FeatureSet();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    reader.readMessage(message.features, () => pb_1.Message.addToRepeatedWrapperField(message, 2, StarCCMFeature.deserialize(reader), StarCCMFeature));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return FeatureSet.deserialize(bytes);
    }
}
exports.FeatureSet = FeatureSet;
_FeatureSet_one_of_decls = new WeakMap();
class StarCCMFeature extends pb_1.Message {
    constructor(data) {
        super();
        _StarCCMFeature_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _StarCCMFeature_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("count" in data && data.count != undefined) {
                this.count = data.count;
            }
        }
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get count() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0);
    }
    set count(value) {
        pb_1.Message.setField(this, 2, value);
    }
    static fromObject(data) {
        const message = new StarCCMFeature({});
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.count != null) {
            message.count = data.count;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.count != null) {
            data.count = this.count;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.name.length)
            writer.writeString(1, this.name);
        if (this.count != 0)
            writer.writeInt32(2, this.count);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StarCCMFeature();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.name = reader.readString();
                    break;
                case 2:
                    message.count = reader.readInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return StarCCMFeature.deserialize(bytes);
    }
}
exports.StarCCMFeature = StarCCMFeature;
_StarCCMFeature_one_of_decls = new WeakMap();
class CoreType extends pb_1.Message {
    constructor(data) {
        super();
        _CoreType_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [8, 16, 24, 30], __classPrivateFieldGet(this, _CoreType_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("code" in data && data.code != undefined) {
                this.code = data.code;
            }
            if ("compute" in data && data.compute != undefined) {
                this.compute = data.compute;
            }
            if ("io" in data && data.io != undefined) {
                this.io = data.io;
            }
            if ("memory" in data && data.memory != undefined) {
                this.memory = data.memory;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("storage" in data && data.storage != undefined) {
                this.storage = data.storage;
            }
            if ("storageIo" in data && data.storageIo != undefined) {
                this.storageIo = data.storageIo;
            }
            if ("cores" in data && data.cores != undefined) {
                this.cores = data.cores;
            }
            if ("storagePerNodeGib" in data && data.storagePerNodeGib != undefined) {
                this.storagePerNodeGib = data.storagePerNodeGib;
            }
            if ("description" in data && data.description != undefined) {
                this.description = data.description;
            }
            if ("displayOrder" in data && data.displayOrder != undefined) {
                this.displayOrder = data.displayOrder;
            }
            if ("isPrimary" in data && data.isPrimary != undefined) {
                this.isPrimary = data.isPrimary;
            }
            if ("hasSsd" in data && data.hasSsd != undefined) {
                this.hasSsd = data.hasSsd;
            }
            if ("processorInfo" in data && data.processorInfo != undefined) {
                this.processorInfo = data.processorInfo;
            }
            if ("remoteVizAllowed" in data && data.remoteVizAllowed != undefined) {
                this.remoteVizAllowed = data.remoteVizAllowed;
            }
            if ("features" in data && data.features != undefined) {
                this.features = data.features;
            }
            if ("mustBeRequested" in data && data.mustBeRequested != undefined) {
                this.mustBeRequested = data.mustBeRequested;
            }
            if ("acronym" in data && data.acronym != undefined) {
                this.acronym = data.acronym;
            }
            if ("color" in data && data.color != undefined) {
                this.color = data.color;
            }
            if ("isLowPriorityBeta" in data && data.isLowPriorityBeta != undefined) {
                this.isLowPriorityBeta = data.isLowPriorityBeta;
            }
            if ("isDefault" in data && data.isDefault != undefined) {
                this.isDefault = data.isDefault;
            }
            if ("baseClockSpeed" in data && data.baseClockSpeed != undefined) {
                this.baseClockSpeed = data.baseClockSpeed;
            }
            if ("boostClockSpeed" in data && data.boostClockSpeed != undefined) {
                this.boostClockSpeed = data.boostClockSpeed;
            }
            if ("gpuCounts" in data && data.gpuCounts != undefined) {
                this.gpuCounts = data.gpuCounts;
            }
            if ("gpuInfo" in data && data.gpuInfo != undefined) {
                this.gpuInfo = data.gpuInfo;
            }
            if ("requiresTempSshAuth" in data && data.requiresTempSshAuth != undefined) {
                this.requiresTempSshAuth = data.requiresTempSshAuth;
            }
            if ("permitPriorityCompute" in data && data.permitPriorityCompute != undefined) {
                this.permitPriorityCompute = data.permitPriorityCompute;
            }
            if ("permitLowPriorityCompute" in data && data.permitLowPriorityCompute != undefined) {
                this.permitLowPriorityCompute = data.permitLowPriorityCompute;
            }
            if ("permitReservedCompute" in data && data.permitReservedCompute != undefined) {
                this.permitReservedCompute = data.permitReservedCompute;
            }
            if ("categoryCodes" in data && data.categoryCodes != undefined) {
                this.categoryCodes = data.categoryCodes;
            }
            if ("networkInformation" in data && data.networkInformation != undefined) {
                this.networkInformation = data.networkInformation;
            }
            if ("networkBandwidthGbps" in data && data.networkBandwidthGbps != undefined) {
                this.networkBandwidthGbps = data.networkBandwidthGbps;
            }
            if ("networkLatencyUs" in data && data.networkLatencyUs != undefined) {
                this.networkLatencyUs = data.networkLatencyUs;
            }
            if ("memoryPerCoreGb" in data && data.memoryPerCoreGb != undefined) {
                this.memoryPerCoreGb = data.memoryPerCoreGb;
            }
            if ("instructionSet" in data && data.instructionSet != undefined) {
                this.instructionSet = data.instructionSet;
            }
            if ("storageInformation" in data && data.storageInformation != undefined) {
                this.storageInformation = data.storageInformation;
            }
            if ("isEbsBacked" in data && data.isEbsBacked != undefined) {
                this.isEbsBacked = data.isEbsBacked;
            }
            if ("supportsSuspension" in data && data.supportsSuspension != undefined) {
                this.supportsSuspension = data.supportsSuspension;
            }
        }
    }
    get code() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set code(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get compute() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set compute(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get io() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set io(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get memory() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0);
    }
    set memory(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 5, value);
    }
    get storage() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0);
    }
    set storage(value) {
        pb_1.Message.setField(this, 6, value);
    }
    get storageIo() {
        return pb_1.Message.getFieldWithDefault(this, 7, "");
    }
    set storageIo(value) {
        pb_1.Message.setField(this, 7, value);
    }
    get cores() {
        return pb_1.Message.getFieldWithDefault(this, 8, []);
    }
    set cores(value) {
        pb_1.Message.setField(this, 8, value);
    }
    get storagePerNodeGib() {
        return pb_1.Message.getFieldWithDefault(this, 9, 0);
    }
    set storagePerNodeGib(value) {
        pb_1.Message.setField(this, 9, value);
    }
    get description() {
        return pb_1.Message.getFieldWithDefault(this, 10, "");
    }
    set description(value) {
        pb_1.Message.setField(this, 10, value);
    }
    get displayOrder() {
        return pb_1.Message.getFieldWithDefault(this, 11, 0);
    }
    set displayOrder(value) {
        pb_1.Message.setField(this, 11, value);
    }
    get isPrimary() {
        return pb_1.Message.getFieldWithDefault(this, 12, false);
    }
    set isPrimary(value) {
        pb_1.Message.setField(this, 12, value);
    }
    get hasSsd() {
        return pb_1.Message.getFieldWithDefault(this, 13, false);
    }
    set hasSsd(value) {
        pb_1.Message.setField(this, 13, value);
    }
    get processorInfo() {
        return pb_1.Message.getFieldWithDefault(this, 14, "");
    }
    set processorInfo(value) {
        pb_1.Message.setField(this, 14, value);
    }
    get remoteVizAllowed() {
        return pb_1.Message.getFieldWithDefault(this, 15, false);
    }
    set remoteVizAllowed(value) {
        pb_1.Message.setField(this, 15, value);
    }
    get features() {
        return pb_1.Message.getFieldWithDefault(this, 16, []);
    }
    set features(value) {
        pb_1.Message.setField(this, 16, value);
    }
    get mustBeRequested() {
        return pb_1.Message.getFieldWithDefault(this, 17, false);
    }
    set mustBeRequested(value) {
        pb_1.Message.setField(this, 17, value);
    }
    get acronym() {
        return pb_1.Message.getFieldWithDefault(this, 18, "");
    }
    set acronym(value) {
        pb_1.Message.setField(this, 18, value);
    }
    get color() {
        return pb_1.Message.getFieldWithDefault(this, 19, "");
    }
    set color(value) {
        pb_1.Message.setField(this, 19, value);
    }
    get isLowPriorityBeta() {
        return pb_1.Message.getFieldWithDefault(this, 20, false);
    }
    set isLowPriorityBeta(value) {
        pb_1.Message.setField(this, 20, value);
    }
    get isDefault() {
        return pb_1.Message.getFieldWithDefault(this, 21, false);
    }
    set isDefault(value) {
        pb_1.Message.setField(this, 21, value);
    }
    get baseClockSpeed() {
        return pb_1.Message.getFieldWithDefault(this, 22, "");
    }
    set baseClockSpeed(value) {
        pb_1.Message.setField(this, 22, value);
    }
    get boostClockSpeed() {
        return pb_1.Message.getFieldWithDefault(this, 23, "");
    }
    set boostClockSpeed(value) {
        pb_1.Message.setField(this, 23, value);
    }
    get gpuCounts() {
        return pb_1.Message.getFieldWithDefault(this, 24, []);
    }
    set gpuCounts(value) {
        pb_1.Message.setField(this, 24, value);
    }
    get gpuInfo() {
        return pb_1.Message.getFieldWithDefault(this, 25, "");
    }
    set gpuInfo(value) {
        pb_1.Message.setField(this, 25, value);
    }
    get requiresTempSshAuth() {
        return pb_1.Message.getFieldWithDefault(this, 26, false);
    }
    set requiresTempSshAuth(value) {
        pb_1.Message.setField(this, 26, value);
    }
    get permitPriorityCompute() {
        return pb_1.Message.getFieldWithDefault(this, 27, false);
    }
    set permitPriorityCompute(value) {
        pb_1.Message.setField(this, 27, value);
    }
    get permitLowPriorityCompute() {
        return pb_1.Message.getFieldWithDefault(this, 28, false);
    }
    set permitLowPriorityCompute(value) {
        pb_1.Message.setField(this, 28, value);
    }
    get permitReservedCompute() {
        return pb_1.Message.getFieldWithDefault(this, 29, false);
    }
    set permitReservedCompute(value) {
        pb_1.Message.setField(this, 29, value);
    }
    get categoryCodes() {
        return pb_1.Message.getFieldWithDefault(this, 30, []);
    }
    set categoryCodes(value) {
        pb_1.Message.setField(this, 30, value);
    }
    get networkInformation() {
        return pb_1.Message.getFieldWithDefault(this, 31, "");
    }
    set networkInformation(value) {
        pb_1.Message.setField(this, 31, value);
    }
    get networkBandwidthGbps() {
        return pb_1.Message.getFieldWithDefault(this, 32, "");
    }
    set networkBandwidthGbps(value) {
        pb_1.Message.setField(this, 32, value);
    }
    get networkLatencyUs() {
        return pb_1.Message.getFieldWithDefault(this, 33, "");
    }
    set networkLatencyUs(value) {
        pb_1.Message.setField(this, 33, value);
    }
    get memoryPerCoreGb() {
        return pb_1.Message.getFieldWithDefault(this, 34, "");
    }
    set memoryPerCoreGb(value) {
        pb_1.Message.setField(this, 34, value);
    }
    get instructionSet() {
        return pb_1.Message.getFieldWithDefault(this, 35, "");
    }
    set instructionSet(value) {
        pb_1.Message.setField(this, 35, value);
    }
    get storageInformation() {
        return pb_1.Message.getFieldWithDefault(this, 36, "");
    }
    set storageInformation(value) {
        pb_1.Message.setField(this, 36, value);
    }
    get isEbsBacked() {
        return pb_1.Message.getFieldWithDefault(this, 37, false);
    }
    set isEbsBacked(value) {
        pb_1.Message.setField(this, 37, value);
    }
    get supportsSuspension() {
        return pb_1.Message.getFieldWithDefault(this, 38, false);
    }
    set supportsSuspension(value) {
        pb_1.Message.setField(this, 38, value);
    }
    static fromObject(data) {
        const message = new CoreType({});
        if (data.code != null) {
            message.code = data.code;
        }
        if (data.compute != null) {
            message.compute = data.compute;
        }
        if (data.io != null) {
            message.io = data.io;
        }
        if (data.memory != null) {
            message.memory = data.memory;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.storage != null) {
            message.storage = data.storage;
        }
        if (data.storageIo != null) {
            message.storageIo = data.storageIo;
        }
        if (data.cores != null) {
            message.cores = data.cores;
        }
        if (data.storagePerNodeGib != null) {
            message.storagePerNodeGib = data.storagePerNodeGib;
        }
        if (data.description != null) {
            message.description = data.description;
        }
        if (data.displayOrder != null) {
            message.displayOrder = data.displayOrder;
        }
        if (data.isPrimary != null) {
            message.isPrimary = data.isPrimary;
        }
        if (data.hasSsd != null) {
            message.hasSsd = data.hasSsd;
        }
        if (data.processorInfo != null) {
            message.processorInfo = data.processorInfo;
        }
        if (data.remoteVizAllowed != null) {
            message.remoteVizAllowed = data.remoteVizAllowed;
        }
        if (data.features != null) {
            message.features = data.features;
        }
        if (data.mustBeRequested != null) {
            message.mustBeRequested = data.mustBeRequested;
        }
        if (data.acronym != null) {
            message.acronym = data.acronym;
        }
        if (data.color != null) {
            message.color = data.color;
        }
        if (data.isLowPriorityBeta != null) {
            message.isLowPriorityBeta = data.isLowPriorityBeta;
        }
        if (data.isDefault != null) {
            message.isDefault = data.isDefault;
        }
        if (data.baseClockSpeed != null) {
            message.baseClockSpeed = data.baseClockSpeed;
        }
        if (data.boostClockSpeed != null) {
            message.boostClockSpeed = data.boostClockSpeed;
        }
        if (data.gpuCounts != null) {
            message.gpuCounts = data.gpuCounts;
        }
        if (data.gpuInfo != null) {
            message.gpuInfo = data.gpuInfo;
        }
        if (data.requiresTempSshAuth != null) {
            message.requiresTempSshAuth = data.requiresTempSshAuth;
        }
        if (data.permitPriorityCompute != null) {
            message.permitPriorityCompute = data.permitPriorityCompute;
        }
        if (data.permitLowPriorityCompute != null) {
            message.permitLowPriorityCompute = data.permitLowPriorityCompute;
        }
        if (data.permitReservedCompute != null) {
            message.permitReservedCompute = data.permitReservedCompute;
        }
        if (data.categoryCodes != null) {
            message.categoryCodes = data.categoryCodes;
        }
        if (data.networkInformation != null) {
            message.networkInformation = data.networkInformation;
        }
        if (data.networkBandwidthGbps != null) {
            message.networkBandwidthGbps = data.networkBandwidthGbps;
        }
        if (data.networkLatencyUs != null) {
            message.networkLatencyUs = data.networkLatencyUs;
        }
        if (data.memoryPerCoreGb != null) {
            message.memoryPerCoreGb = data.memoryPerCoreGb;
        }
        if (data.instructionSet != null) {
            message.instructionSet = data.instructionSet;
        }
        if (data.storageInformation != null) {
            message.storageInformation = data.storageInformation;
        }
        if (data.isEbsBacked != null) {
            message.isEbsBacked = data.isEbsBacked;
        }
        if (data.supportsSuspension != null) {
            message.supportsSuspension = data.supportsSuspension;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.code != null) {
            data.code = this.code;
        }
        if (this.compute != null) {
            data.compute = this.compute;
        }
        if (this.io != null) {
            data.io = this.io;
        }
        if (this.memory != null) {
            data.memory = this.memory;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.storage != null) {
            data.storage = this.storage;
        }
        if (this.storageIo != null) {
            data.storageIo = this.storageIo;
        }
        if (this.cores != null) {
            data.cores = this.cores;
        }
        if (this.storagePerNodeGib != null) {
            data.storagePerNodeGib = this.storagePerNodeGib;
        }
        if (this.description != null) {
            data.description = this.description;
        }
        if (this.displayOrder != null) {
            data.displayOrder = this.displayOrder;
        }
        if (this.isPrimary != null) {
            data.isPrimary = this.isPrimary;
        }
        if (this.hasSsd != null) {
            data.hasSsd = this.hasSsd;
        }
        if (this.processorInfo != null) {
            data.processorInfo = this.processorInfo;
        }
        if (this.remoteVizAllowed != null) {
            data.remoteVizAllowed = this.remoteVizAllowed;
        }
        if (this.features != null) {
            data.features = this.features;
        }
        if (this.mustBeRequested != null) {
            data.mustBeRequested = this.mustBeRequested;
        }
        if (this.acronym != null) {
            data.acronym = this.acronym;
        }
        if (this.color != null) {
            data.color = this.color;
        }
        if (this.isLowPriorityBeta != null) {
            data.isLowPriorityBeta = this.isLowPriorityBeta;
        }
        if (this.isDefault != null) {
            data.isDefault = this.isDefault;
        }
        if (this.baseClockSpeed != null) {
            data.baseClockSpeed = this.baseClockSpeed;
        }
        if (this.boostClockSpeed != null) {
            data.boostClockSpeed = this.boostClockSpeed;
        }
        if (this.gpuCounts != null) {
            data.gpuCounts = this.gpuCounts;
        }
        if (this.gpuInfo != null) {
            data.gpuInfo = this.gpuInfo;
        }
        if (this.requiresTempSshAuth != null) {
            data.requiresTempSshAuth = this.requiresTempSshAuth;
        }
        if (this.permitPriorityCompute != null) {
            data.permitPriorityCompute = this.permitPriorityCompute;
        }
        if (this.permitLowPriorityCompute != null) {
            data.permitLowPriorityCompute = this.permitLowPriorityCompute;
        }
        if (this.permitReservedCompute != null) {
            data.permitReservedCompute = this.permitReservedCompute;
        }
        if (this.categoryCodes != null) {
            data.categoryCodes = this.categoryCodes;
        }
        if (this.networkInformation != null) {
            data.networkInformation = this.networkInformation;
        }
        if (this.networkBandwidthGbps != null) {
            data.networkBandwidthGbps = this.networkBandwidthGbps;
        }
        if (this.networkLatencyUs != null) {
            data.networkLatencyUs = this.networkLatencyUs;
        }
        if (this.memoryPerCoreGb != null) {
            data.memoryPerCoreGb = this.memoryPerCoreGb;
        }
        if (this.instructionSet != null) {
            data.instructionSet = this.instructionSet;
        }
        if (this.storageInformation != null) {
            data.storageInformation = this.storageInformation;
        }
        if (this.isEbsBacked != null) {
            data.isEbsBacked = this.isEbsBacked;
        }
        if (this.supportsSuspension != null) {
            data.supportsSuspension = this.supportsSuspension;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.code.length)
            writer.writeString(1, this.code);
        if (this.compute.length)
            writer.writeString(2, this.compute);
        if (this.io.length)
            writer.writeString(3, this.io);
        if (this.memory != 0)
            writer.writeFloat(4, this.memory);
        if (this.name.length)
            writer.writeString(5, this.name);
        if (this.storage != 0)
            writer.writeFloat(6, this.storage);
        if (this.storageIo.length)
            writer.writeString(7, this.storageIo);
        if (this.cores.length)
            writer.writePackedInt32(8, this.cores);
        if (this.storagePerNodeGib != 0)
            writer.writeInt32(9, this.storagePerNodeGib);
        if (this.description.length)
            writer.writeString(10, this.description);
        if (this.displayOrder != 0)
            writer.writeInt32(11, this.displayOrder);
        if (this.isPrimary != false)
            writer.writeBool(12, this.isPrimary);
        if (this.hasSsd != false)
            writer.writeBool(13, this.hasSsd);
        if (this.processorInfo.length)
            writer.writeString(14, this.processorInfo);
        if (this.remoteVizAllowed != false)
            writer.writeBool(15, this.remoteVizAllowed);
        if (this.features.length)
            writer.writeRepeatedString(16, this.features);
        if (this.mustBeRequested != false)
            writer.writeBool(17, this.mustBeRequested);
        if (this.acronym.length)
            writer.writeString(18, this.acronym);
        if (this.color.length)
            writer.writeString(19, this.color);
        if (this.isLowPriorityBeta != false)
            writer.writeBool(20, this.isLowPriorityBeta);
        if (this.isDefault != false)
            writer.writeBool(21, this.isDefault);
        if (this.baseClockSpeed.length)
            writer.writeString(22, this.baseClockSpeed);
        if (this.boostClockSpeed.length)
            writer.writeString(23, this.boostClockSpeed);
        if (this.gpuCounts.length)
            writer.writePackedFloat(24, this.gpuCounts);
        if (this.gpuInfo.length)
            writer.writeString(25, this.gpuInfo);
        if (this.requiresTempSshAuth != false)
            writer.writeBool(26, this.requiresTempSshAuth);
        if (this.permitPriorityCompute != false)
            writer.writeBool(27, this.permitPriorityCompute);
        if (this.permitLowPriorityCompute != false)
            writer.writeBool(28, this.permitLowPriorityCompute);
        if (this.permitReservedCompute != false)
            writer.writeBool(29, this.permitReservedCompute);
        if (this.categoryCodes.length)
            writer.writeRepeatedString(30, this.categoryCodes);
        if (this.networkInformation.length)
            writer.writeString(31, this.networkInformation);
        if (this.networkBandwidthGbps.length)
            writer.writeString(32, this.networkBandwidthGbps);
        if (this.networkLatencyUs.length)
            writer.writeString(33, this.networkLatencyUs);
        if (this.memoryPerCoreGb.length)
            writer.writeString(34, this.memoryPerCoreGb);
        if (this.instructionSet.length)
            writer.writeString(35, this.instructionSet);
        if (this.storageInformation.length)
            writer.writeString(36, this.storageInformation);
        if (this.isEbsBacked != false)
            writer.writeBool(37, this.isEbsBacked);
        if (this.supportsSuspension != false)
            writer.writeBool(38, this.supportsSuspension);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CoreType();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.code = reader.readString();
                    break;
                case 2:
                    message.compute = reader.readString();
                    break;
                case 3:
                    message.io = reader.readString();
                    break;
                case 4:
                    message.memory = reader.readFloat();
                    break;
                case 5:
                    message.name = reader.readString();
                    break;
                case 6:
                    message.storage = reader.readFloat();
                    break;
                case 7:
                    message.storageIo = reader.readString();
                    break;
                case 8:
                    message.cores = reader.readPackedInt32();
                    break;
                case 9:
                    message.storagePerNodeGib = reader.readInt32();
                    break;
                case 10:
                    message.description = reader.readString();
                    break;
                case 11:
                    message.displayOrder = reader.readInt32();
                    break;
                case 12:
                    message.isPrimary = reader.readBool();
                    break;
                case 13:
                    message.hasSsd = reader.readBool();
                    break;
                case 14:
                    message.processorInfo = reader.readString();
                    break;
                case 15:
                    message.remoteVizAllowed = reader.readBool();
                    break;
                case 16:
                    pb_1.Message.addToRepeatedField(message, 16, reader.readString());
                    break;
                case 17:
                    message.mustBeRequested = reader.readBool();
                    break;
                case 18:
                    message.acronym = reader.readString();
                    break;
                case 19:
                    message.color = reader.readString();
                    break;
                case 20:
                    message.isLowPriorityBeta = reader.readBool();
                    break;
                case 21:
                    message.isDefault = reader.readBool();
                    break;
                case 22:
                    message.baseClockSpeed = reader.readString();
                    break;
                case 23:
                    message.boostClockSpeed = reader.readString();
                    break;
                case 24:
                    message.gpuCounts = reader.readPackedFloat();
                    break;
                case 25:
                    message.gpuInfo = reader.readString();
                    break;
                case 26:
                    message.requiresTempSshAuth = reader.readBool();
                    break;
                case 27:
                    message.permitPriorityCompute = reader.readBool();
                    break;
                case 28:
                    message.permitLowPriorityCompute = reader.readBool();
                    break;
                case 29:
                    message.permitReservedCompute = reader.readBool();
                    break;
                case 30:
                    pb_1.Message.addToRepeatedField(message, 30, reader.readString());
                    break;
                case 31:
                    message.networkInformation = reader.readString();
                    break;
                case 32:
                    message.networkBandwidthGbps = reader.readString();
                    break;
                case 33:
                    message.networkLatencyUs = reader.readString();
                    break;
                case 34:
                    message.memoryPerCoreGb = reader.readString();
                    break;
                case 35:
                    message.instructionSet = reader.readString();
                    break;
                case 36:
                    message.storageInformation = reader.readString();
                    break;
                case 37:
                    message.isEbsBacked = reader.readBool();
                    break;
                case 38:
                    message.supportsSuspension = reader.readBool();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return CoreType.deserialize(bytes);
    }
}
exports.CoreType = CoreType;
_CoreType_one_of_decls = new WeakMap();
class RescaleJobVariable extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobVariable_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], __classPrivateFieldGet(this, _RescaleJobVariable_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("displayOrder" in data && data.displayOrder != undefined) {
                this.displayOrder = data.displayOrder;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("valueGeneratorSettings" in data && data.valueGeneratorSettings != undefined) {
                this.valueGeneratorSettings = data.valueGeneratorSettings;
            }
            if ("valueGeneratorType" in data && data.valueGeneratorType != undefined) {
                this.valueGeneratorType = data.valueGeneratorType;
            }
            if ("variableType" in data && data.variableType != undefined) {
                this.variableType = data.variableType;
            }
        }
    }
    get displayOrder() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set displayOrder(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get valueGeneratorSettings() {
        return pb_1.Message.getFieldWithDefault(this, 3, []);
    }
    set valueGeneratorSettings(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get valueGeneratorType() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set valueGeneratorType(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get variableType() {
        return pb_1.Message.getFieldWithDefault(this, 5, "");
    }
    set variableType(value) {
        pb_1.Message.setField(this, 5, value);
    }
    static fromObject(data) {
        const message = new RescaleJobVariable({});
        if (data.displayOrder != null) {
            message.displayOrder = data.displayOrder;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.valueGeneratorSettings != null) {
            message.valueGeneratorSettings = data.valueGeneratorSettings;
        }
        if (data.valueGeneratorType != null) {
            message.valueGeneratorType = data.valueGeneratorType;
        }
        if (data.variableType != null) {
            message.variableType = data.variableType;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.displayOrder != null) {
            data.displayOrder = this.displayOrder;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.valueGeneratorSettings != null) {
            data.valueGeneratorSettings = this.valueGeneratorSettings;
        }
        if (this.valueGeneratorType != null) {
            data.valueGeneratorType = this.valueGeneratorType;
        }
        if (this.variableType != null) {
            data.variableType = this.variableType;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.displayOrder != 0)
            writer.writeInt32(1, this.displayOrder);
        if (this.name.length)
            writer.writeString(2, this.name);
        if (this.valueGeneratorSettings.length)
            writer.writeRepeatedString(3, this.valueGeneratorSettings);
        if (this.valueGeneratorType.length)
            writer.writeString(4, this.valueGeneratorType);
        if (this.variableType.length)
            writer.writeString(5, this.variableType);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobVariable();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.displayOrder = reader.readInt32();
                    break;
                case 2:
                    message.name = reader.readString();
                    break;
                case 3:
                    pb_1.Message.addToRepeatedField(message, 3, reader.readString());
                    break;
                case 4:
                    message.valueGeneratorType = reader.readString();
                    break;
                case 5:
                    message.variableType = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobVariable.deserialize(bytes);
    }
}
exports.RescaleJobVariable = RescaleJobVariable;
_RescaleJobVariable_one_of_decls = new WeakMap();
class RescaleResourceFilter extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleResourceFilter_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RescaleResourceFilter_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("caseSensitive" in data && data.caseSensitive != undefined) {
                this.caseSensitive = data.caseSensitive;
            }
            if ("include" in data && data.include != undefined) {
                this.include = data.include;
            }
            if ("filterType" in data && data.filterType != undefined) {
                this.filterType = data.filterType;
            }
            if ("selector" in data && data.selector != undefined) {
                this.selector = data.selector;
            }
        }
    }
    get caseSensitive() {
        return pb_1.Message.getFieldWithDefault(this, 1, false);
    }
    set caseSensitive(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get include() {
        return pb_1.Message.getFieldWithDefault(this, 2, false);
    }
    set include(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get filterType() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set filterType(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get selector() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set selector(value) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data) {
        const message = new RescaleResourceFilter({});
        if (data.caseSensitive != null) {
            message.caseSensitive = data.caseSensitive;
        }
        if (data.include != null) {
            message.include = data.include;
        }
        if (data.filterType != null) {
            message.filterType = data.filterType;
        }
        if (data.selector != null) {
            message.selector = data.selector;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.caseSensitive != null) {
            data.caseSensitive = this.caseSensitive;
        }
        if (this.include != null) {
            data.include = this.include;
        }
        if (this.filterType != null) {
            data.filterType = this.filterType;
        }
        if (this.selector != null) {
            data.selector = this.selector;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.caseSensitive != false)
            writer.writeBool(1, this.caseSensitive);
        if (this.include != false)
            writer.writeBool(2, this.include);
        if (this.filterType.length)
            writer.writeString(3, this.filterType);
        if (this.selector.length)
            writer.writeString(4, this.selector);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleResourceFilter();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.caseSensitive = reader.readBool();
                    break;
                case 2:
                    message.include = reader.readBool();
                    break;
                case 3:
                    message.filterType = reader.readString();
                    break;
                case 4:
                    message.selector = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleResourceFilter.deserialize(bytes);
    }
}
exports.RescaleResourceFilter = RescaleResourceFilter;
_RescaleResourceFilter_one_of_decls = new WeakMap();
class RescaleJobJSONResult extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobJSONResult_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RescaleJobJSONResult_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("rescaleJobAsJSON" in data && data.rescaleJobAsJSON != undefined) {
                this.rescaleJobAsJSON = data.rescaleJobAsJSON;
            }
            if ("queryString" in data && data.queryString != undefined) {
                this.queryString = data.queryString;
            }
            if ("resultMsgText" in data && data.resultMsgText != undefined) {
                this.resultMsgText = data.resultMsgText;
            }
            if ("workflowTaskId" in data && data.workflowTaskId != undefined) {
                this.workflowTaskId = data.workflowTaskId;
            }
            if ("rescaleJobResult" in data && data.rescaleJobResult != undefined) {
                this.rescaleJobResult = data.rescaleJobResult;
            }
        }
    }
    get rescaleJobAsJSON() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set rescaleJobAsJSON(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get queryString() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set queryString(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get resultMsgText() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set resultMsgText(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get workflowTaskId() {
        return pb_1.Message.getFieldWithDefault(this, 4, "");
    }
    set workflowTaskId(value) {
        pb_1.Message.setField(this, 4, value);
    }
    get rescaleJobResult() {
        return pb_1.Message.getWrapperField(this, RescaleJobResult, 5);
    }
    set rescaleJobResult(value) {
        pb_1.Message.setWrapperField(this, 5, value);
    }
    get has_rescaleJobResult() {
        return pb_1.Message.getField(this, 5) != null;
    }
    static fromObject(data) {
        const message = new RescaleJobJSONResult({});
        if (data.rescaleJobAsJSON != null) {
            message.rescaleJobAsJSON = data.rescaleJobAsJSON;
        }
        if (data.queryString != null) {
            message.queryString = data.queryString;
        }
        if (data.resultMsgText != null) {
            message.resultMsgText = data.resultMsgText;
        }
        if (data.workflowTaskId != null) {
            message.workflowTaskId = data.workflowTaskId;
        }
        if (data.rescaleJobResult != null) {
            message.rescaleJobResult = RescaleJobResult.fromObject(data.rescaleJobResult);
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.rescaleJobAsJSON != null) {
            data.rescaleJobAsJSON = this.rescaleJobAsJSON;
        }
        if (this.queryString != null) {
            data.queryString = this.queryString;
        }
        if (this.resultMsgText != null) {
            data.resultMsgText = this.resultMsgText;
        }
        if (this.workflowTaskId != null) {
            data.workflowTaskId = this.workflowTaskId;
        }
        if (this.rescaleJobResult != null) {
            data.rescaleJobResult = this.rescaleJobResult.toObject();
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.rescaleJobAsJSON.length)
            writer.writeString(1, this.rescaleJobAsJSON);
        if (this.queryString.length)
            writer.writeString(2, this.queryString);
        if (this.resultMsgText.length)
            writer.writeString(3, this.resultMsgText);
        if (this.workflowTaskId.length)
            writer.writeString(4, this.workflowTaskId);
        if (this.has_rescaleJobResult)
            writer.writeMessage(5, this.rescaleJobResult, () => this.rescaleJobResult.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobJSONResult();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.rescaleJobAsJSON = reader.readString();
                    break;
                case 2:
                    message.queryString = reader.readString();
                    break;
                case 3:
                    message.resultMsgText = reader.readString();
                    break;
                case 4:
                    message.workflowTaskId = reader.readString();
                    break;
                case 5:
                    reader.readMessage(message.rescaleJobResult, () => message.rescaleJobResult = RescaleJobResult.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobJSONResult.deserialize(bytes);
    }
}
exports.RescaleJobJSONResult = RescaleJobJSONResult;
_RescaleJobJSONResult_one_of_decls = new WeakMap();
class RescaleJobOutFiles extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobOutFiles_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4], __classPrivateFieldGet(this, _RescaleJobOutFiles_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("count" in data && data.count != undefined) {
                this.count = data.count;
            }
            if ("next" in data && data.next != undefined) {
                this.next = data.next;
            }
            if ("previous" in data && data.previous != undefined) {
                this.previous = data.previous;
            }
            if ("results" in data && data.results != undefined) {
                this.results = data.results;
            }
        }
    }
    get count() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set count(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get next() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set next(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get previous() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set previous(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get results() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleJobOutFileDetail, 4);
    }
    set results(value) {
        pb_1.Message.setRepeatedWrapperField(this, 4, value);
    }
    static fromObject(data) {
        const message = new RescaleJobOutFiles({});
        if (data.count != null) {
            message.count = data.count;
        }
        if (data.next != null) {
            message.next = data.next;
        }
        if (data.previous != null) {
            message.previous = data.previous;
        }
        if (data.results != null) {
            message.results = data.results.map(item => RescaleJobOutFileDetail.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.count != null) {
            data.count = this.count;
        }
        if (this.next != null) {
            data.next = this.next;
        }
        if (this.previous != null) {
            data.previous = this.previous;
        }
        if (this.results != null) {
            data.results = this.results.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.count != 0)
            writer.writeInt32(1, this.count);
        if (this.next.length)
            writer.writeString(2, this.next);
        if (this.previous.length)
            writer.writeString(3, this.previous);
        if (this.results.length)
            writer.writeRepeatedMessage(4, this.results, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobOutFiles();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.count = reader.readInt32();
                    break;
                case 2:
                    message.next = reader.readString();
                    break;
                case 3:
                    message.previous = reader.readString();
                    break;
                case 4:
                    reader.readMessage(message.results, () => pb_1.Message.addToRepeatedWrapperField(message, 4, RescaleJobOutFileDetail.deserialize(reader), RescaleJobOutFileDetail));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobOutFiles.deserialize(bytes);
    }
}
exports.RescaleJobOutFiles = RescaleJobOutFiles;
_RescaleJobOutFiles_one_of_decls = new WeakMap();
class RescaleJobOutFileDetail extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobOutFileDetail_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RescaleJobOutFileDetail_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("rescaleJobOutFileAsJSON" in data && data.rescaleJobOutFileAsJSON != undefined) {
                this.rescaleJobOutFileAsJSON = data.rescaleJobOutFileAsJSON;
            }
        }
    }
    get rescaleJobOutFileAsJSON() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set rescaleJobOutFileAsJSON(value) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data) {
        const message = new RescaleJobOutFileDetail({});
        if (data.rescaleJobOutFileAsJSON != null) {
            message.rescaleJobOutFileAsJSON = data.rescaleJobOutFileAsJSON;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.rescaleJobOutFileAsJSON != null) {
            data.rescaleJobOutFileAsJSON = this.rescaleJobOutFileAsJSON;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.rescaleJobOutFileAsJSON.length)
            writer.writeString(1, this.rescaleJobOutFileAsJSON);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobOutFileDetail();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.rescaleJobOutFileAsJSON = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobOutFileDetail.deserialize(bytes);
    }
}
exports.RescaleJobOutFileDetail = RescaleJobOutFileDetail;
_RescaleJobOutFileDetail_one_of_decls = new WeakMap();
class RescaleJobResult extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobResult_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RescaleJobResult_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) {
                this.id = data.id;
            }
            if ("isLowPriority" in data && data.isLowPriority != undefined) {
                this.isLowPriority = data.isLowPriority;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
        }
    }
    get id() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set id(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get isLowPriority() {
        return pb_1.Message.getFieldWithDefault(this, 2, false);
    }
    set isLowPriority(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set name(value) {
        pb_1.Message.setField(this, 3, value);
    }
    static fromObject(data) {
        const message = new RescaleJobResult({});
        if (data.id != null) {
            message.id = data.id;
        }
        if (data.isLowPriority != null) {
            message.isLowPriority = data.isLowPriority;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.id != null) {
            data.id = this.id;
        }
        if (this.isLowPriority != null) {
            data.isLowPriority = this.isLowPriority;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.id.length)
            writer.writeString(1, this.id);
        if (this.isLowPriority != false)
            writer.writeBool(2, this.isLowPriority);
        if (this.name.length)
            writer.writeString(3, this.name);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobResult();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.id = reader.readString();
                    break;
                case 2:
                    message.isLowPriority = reader.readBool();
                    break;
                case 3:
                    message.name = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobResult.deserialize(bytes);
    }
}
exports.RescaleJobResult = RescaleJobResult;
_RescaleJobResult_one_of_decls = new WeakMap();
class RescaleJobStatusHistory extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobStatusHistory_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4], __classPrivateFieldGet(this, _RescaleJobStatusHistory_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("count" in data && data.count != undefined) {
                this.count = data.count;
            }
            if ("next" in data && data.next != undefined) {
                this.next = data.next;
            }
            if ("previous" in data && data.previous != undefined) {
                this.previous = data.previous;
            }
            if ("results" in data && data.results != undefined) {
                this.results = data.results;
            }
        }
    }
    get count() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set count(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get next() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set next(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get previous() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set previous(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get results() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleJobStatusHistDetail, 4);
    }
    set results(value) {
        pb_1.Message.setRepeatedWrapperField(this, 4, value);
    }
    static fromObject(data) {
        const message = new RescaleJobStatusHistory({});
        if (data.count != null) {
            message.count = data.count;
        }
        if (data.next != null) {
            message.next = data.next;
        }
        if (data.previous != null) {
            message.previous = data.previous;
        }
        if (data.results != null) {
            message.results = data.results.map(item => RescaleJobStatusHistDetail.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.count != null) {
            data.count = this.count;
        }
        if (this.next != null) {
            data.next = this.next;
        }
        if (this.previous != null) {
            data.previous = this.previous;
        }
        if (this.results != null) {
            data.results = this.results.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.count != 0)
            writer.writeInt32(1, this.count);
        if (this.next.length)
            writer.writeString(2, this.next);
        if (this.previous.length)
            writer.writeString(3, this.previous);
        if (this.results.length)
            writer.writeRepeatedMessage(4, this.results, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobStatusHistory();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.count = reader.readInt32();
                    break;
                case 2:
                    message.next = reader.readString();
                    break;
                case 3:
                    message.previous = reader.readString();
                    break;
                case 4:
                    reader.readMessage(message.results, () => pb_1.Message.addToRepeatedWrapperField(message, 4, RescaleJobStatusHistDetail.deserialize(reader), RescaleJobStatusHistDetail));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobStatusHistory.deserialize(bytes);
    }
}
exports.RescaleJobStatusHistory = RescaleJobStatusHistory;
_RescaleJobStatusHistory_one_of_decls = new WeakMap();
class RescaleJobStatusHistDetail extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleJobStatusHistDetail_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RescaleJobStatusHistDetail_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("rescaleJobStatHistAsJSON" in data && data.rescaleJobStatHistAsJSON != undefined) {
                this.rescaleJobStatHistAsJSON = data.rescaleJobStatHistAsJSON;
            }
        }
    }
    get rescaleJobStatHistAsJSON() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set rescaleJobStatHistAsJSON(value) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data) {
        const message = new RescaleJobStatusHistDetail({});
        if (data.rescaleJobStatHistAsJSON != null) {
            message.rescaleJobStatHistAsJSON = data.rescaleJobStatHistAsJSON;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.rescaleJobStatHistAsJSON != null) {
            data.rescaleJobStatHistAsJSON = this.rescaleJobStatHistAsJSON;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.rescaleJobStatHistAsJSON.length)
            writer.writeString(1, this.rescaleJobStatHistAsJSON);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleJobStatusHistDetail();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.rescaleJobStatHistAsJSON = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleJobStatusHistDetail.deserialize(bytes);
    }
}
exports.RescaleJobStatusHistDetail = RescaleJobStatusHistDetail;
_RescaleJobStatusHistDetail_one_of_decls = new WeakMap();
class RescaleClusterStatusHistory extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleClusterStatusHistory_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4], __classPrivateFieldGet(this, _RescaleClusterStatusHistory_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("count" in data && data.count != undefined) {
                this.count = data.count;
            }
            if ("next" in data && data.next != undefined) {
                this.next = data.next;
            }
            if ("previous" in data && data.previous != undefined) {
                this.previous = data.previous;
            }
            if ("results" in data && data.results != undefined) {
                this.results = data.results;
            }
        }
    }
    get count() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0);
    }
    set count(value) {
        pb_1.Message.setField(this, 1, value);
    }
    get next() {
        return pb_1.Message.getFieldWithDefault(this, 2, "");
    }
    set next(value) {
        pb_1.Message.setField(this, 2, value);
    }
    get previous() {
        return pb_1.Message.getFieldWithDefault(this, 3, "");
    }
    set previous(value) {
        pb_1.Message.setField(this, 3, value);
    }
    get results() {
        return pb_1.Message.getRepeatedWrapperField(this, RescaleClusterStatusHistDetail, 4);
    }
    set results(value) {
        pb_1.Message.setRepeatedWrapperField(this, 4, value);
    }
    static fromObject(data) {
        const message = new RescaleClusterStatusHistory({});
        if (data.count != null) {
            message.count = data.count;
        }
        if (data.next != null) {
            message.next = data.next;
        }
        if (data.previous != null) {
            message.previous = data.previous;
        }
        if (data.results != null) {
            message.results = data.results.map(item => RescaleClusterStatusHistDetail.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.count != null) {
            data.count = this.count;
        }
        if (this.next != null) {
            data.next = this.next;
        }
        if (this.previous != null) {
            data.previous = this.previous;
        }
        if (this.results != null) {
            data.results = this.results.map((item) => item.toObject());
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.count != 0)
            writer.writeInt32(1, this.count);
        if (this.next.length)
            writer.writeString(2, this.next);
        if (this.previous.length)
            writer.writeString(3, this.previous);
        if (this.results.length)
            writer.writeRepeatedMessage(4, this.results, (item) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleClusterStatusHistory();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.count = reader.readInt32();
                    break;
                case 2:
                    message.next = reader.readString();
                    break;
                case 3:
                    message.previous = reader.readString();
                    break;
                case 4:
                    reader.readMessage(message.results, () => pb_1.Message.addToRepeatedWrapperField(message, 4, RescaleClusterStatusHistDetail.deserialize(reader), RescaleClusterStatusHistDetail));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleClusterStatusHistory.deserialize(bytes);
    }
}
exports.RescaleClusterStatusHistory = RescaleClusterStatusHistory;
_RescaleClusterStatusHistory_one_of_decls = new WeakMap();
class RescaleClusterStatusHistDetail extends pb_1.Message {
    constructor(data) {
        super();
        _RescaleClusterStatusHistDetail_one_of_decls.set(this, []);
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _RescaleClusterStatusHistDetail_one_of_decls, "f"));
        if (!Array.isArray(data) && typeof data == "object") {
            if ("rescaleClusterStatHistAsJSON" in data && data.rescaleClusterStatHistAsJSON != undefined) {
                this.rescaleClusterStatHistAsJSON = data.rescaleClusterStatHistAsJSON;
            }
        }
    }
    get rescaleClusterStatHistAsJSON() {
        return pb_1.Message.getFieldWithDefault(this, 1, "");
    }
    set rescaleClusterStatHistAsJSON(value) {
        pb_1.Message.setField(this, 1, value);
    }
    static fromObject(data) {
        const message = new RescaleClusterStatusHistDetail({});
        if (data.rescaleClusterStatHistAsJSON != null) {
            message.rescaleClusterStatHistAsJSON = data.rescaleClusterStatHistAsJSON;
        }
        return message;
    }
    toObject() {
        const data = {};
        if (this.rescaleClusterStatHistAsJSON != null) {
            data.rescaleClusterStatHistAsJSON = this.rescaleClusterStatHistAsJSON;
        }
        return data;
    }
    serialize(w) {
        const writer = w || new pb_1.BinaryWriter();
        if (this.rescaleClusterStatHistAsJSON.length)
            writer.writeString(1, this.rescaleClusterStatHistAsJSON);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes) {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RescaleClusterStatusHistDetail();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.rescaleClusterStatHistAsJSON = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary() {
        return this.serialize();
    }
    static deserializeBinary(bytes) {
        return RescaleClusterStatusHistDetail.deserialize(bytes);
    }
}
exports.RescaleClusterStatusHistDetail = RescaleClusterStatusHistDetail;
_RescaleClusterStatusHistDetail_one_of_decls = new WeakMap();
